import React, { use, useCallback, useEffect, useMemo, useRef, useState } from "react";
import NavbarTop from "../../components/NavbarTop";
import "./style.css"
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { AddAccount, useAuth } from "../../global-components/src";
import { useMessage } from "../../global-components/src";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import { Chat as ChatType, FavoriteMessage, MessageChat, PinnedMessage } from "../../types";
import { ChevronLeft, Clock, Heart, Home, LogOut, Menu, MessageCircle, MoreVertical, Send, Smile, StopCircle, Trash, Upload, Users, X } from "react-feather";
import { clearText, errorMessage, extractFirstUrl, extractYouTubeId, replaceEmojis } from "../../global-components/src/utils/text";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Bell, BellOff, Camera, ChevronDown, ChevronsDown, Clipboard, Copy, Download, File, Gamepad2, Image, Lock, MessageCircleOff, Mic, Pencil, PinOff, Search, Star, Trash2, Reply, UserPlus, XSquare, Pin, Forward, User as UserIcon, Info, Inbox } from "lucide-react";
import { useNotifications, incrementGlobalChatBadge } from "../../hooks/UseNotifications";
import ChatMenu from "../ChatMenu/ChatMenu";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import CreateGroupModal from "../../components/Modals/CreateGroupModal";
import NewConversationPanel from "../../components/NewConversationPanel";
import GroupInfoPanel from "../ChatMenu/GroupInfoPanel";
import ForwardMessageModal from "./forward-message-modal";
import AiMessageContent from "../../components/ai-message-blocks/AiMessageBlocks";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { PACOCA_AI_URL } from "../../utils/vars";
import { detectAiLimitMessage, isAiLimitReached, setAiLimitReached } from "../../utils/aiTokenLimit";
import {
    AiConversation,
    canStartNewAiConversation,
    createConversation,
    deleteConversation,
    deriveTitleFromMessage,
    getConversation,
    loadConversations,
    setActiveConversationId,
    updateConversation,
} from "../../utils/aiConversations";
import AiConversationList from "../../components/ai-conversation-list/AiConversationList";
import AiLimitBanner from "../../components/ai-limit-banner";
import { getImageUser, isMyLove } from "../../global-components/src/utils/auth";
import { isWebView } from "../../global-components/src/utils/text";
import { getAppVersion, getNativeKeyboardHeight, getNativeNavigationHeight, hasNativeMic, isIOSWebView, isNewApp, isNewAppAndroid } from "../../utils/platform";
import PreviewSearch from "../Settings/SearchScreen/preview-search";
import ChatImagePreview from "./chat-image-preview";
import ChatList from "../../components/chat-list";
import { api } from "../../services/api";
import 'highlight.js/styles/github-dark.css';
import { NotificationBadge } from "../../hooks/notifications";
import OpenImg from "../../components/Modals/OpenImg/OpenImg";
import { YoutubePreview } from "../../components/Post/Post/youtube-preview";
import { LinkPreview } from "../../components/Post/Post/link-preview";
import { PostLinkPreview } from "../../components/Post/Post/post-link-preview";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { MessageChatComponent } from "./message-chat";
import { User } from "../../global-components/src/types";
import { t } from "i18next";
import EmojiPickerNative from "../../components/Textarea/Emojis/emoji-picker-native";
import { compressImage, convertHeic } from "../../global-components/src/utils/file";
import hljs from "highlight.js";
import { useThemeEffects } from "../../hooks/useThemeEffects";
import { useAiMentionLimitBanner } from "../../hooks/useAiMentionLimit";
import { useChatEcho } from "../../hooks/useChatEcho";
import { isNearScrollBottom } from "../../utils/scroll-position";
import { getChatListCacheKey, invalidateChatListCache } from "../../utils/chat-list-cache";

interface FilePreview {
    file: File;
    src: string;
}

interface ChatPresenceUser {
    name: string;
    imgAccount?: string | null;
}

const ChatLivePresence = ({
    users,
    recording,
    isGroup,
    fallbackImage,
}: {
    users: ChatPresenceUser[];
    recording: boolean;
    isGroup: boolean;
    fallbackImage?: string | null;
}) => {
    const indicator = recording ? (
        <span className="chat-live-presence-audio" aria-label="gravando áudio">
            <Mic size={15} />
            <span className="chat-live-presence-wave"><i /><i /><i /><i /></span>
        </span>
    ) : (
        <span className="chat-live-presence-dots" aria-label="digitando"><i /><i /><i /></span>
    );

    return (
        <div className={`chat-live-presence ${recording ? "is-recording" : ""} ${isGroup ? "is-group" : ""}`}>
            {isGroup && (
                <div className="chat-live-presence-avatars">
                    {users.slice(0, 2).map((presenceUser, index) => (
                        <img
                            key={`${presenceUser.name}-${index}`}
                            className="chat-live-presence-avatar"
                            style={{ marginLeft: index > 0 ? -9 : 0 }}
                            src={getImagePathBucketPacoca(presenceUser.imgAccount || fallbackImage || "")}
                            onError={(event) => { event.currentTarget.src = "/img/img-account.png"; }}
                            alt=""
                        />
                    ))}
                </div>
            )}
            <div className={isGroup ? "chat-live-presence-group-content" : undefined}>
                {isGroup && <strong className="chat-live-presence-name">{users.map(presenceUser => presenceUser.name).join(", ")}</strong>}
                <div className="chat-live-presence-bubble">{indicator}</div>
            </div>
        </div>
    );
};

const ChatSystemMessage = ({ message, isOwn }: { message: MessageChat; isOwn: boolean }) => {
    const text = message.system_key
        ? t(message.system_key, {
            ...(message.system_params ?? {}),
            actor: isOwn ? t("chat.you", { defaultValue: "Você" }) : (message.user?.name ?? t("chat.unknown", { defaultValue: "Usuário" })),
        })
        : message.text;

    return (
        <div id={`msg-${message.id}`} className="chat-system-message" role="status">
            <span>{text}</span>
        </div>
    );
};

const ias = [
    {
        id: 1,
        name: "Paçoca AI",
        user_name: "pacoca_ai",
        img_account: "/img/pacoca_ai.png"
    },
    {
        id: 2,
        name: "Bochecha AI",
        user_name: "BochechaAI",
        img_account: "/img/bochechaai.png"
    }
] as User[]

/** Returns true for AI conversation IDs — both new ("ia-…") and old ("<timestamp>-<rand>") formats */
const isAiConvId = (id: string) => id.startsWith("ia-") || /^\d{13}-[a-z0-9]+$/.test(id);

const parseMessageFileList = (value?: string | null): string[] => {
    if (!value) return [];

    try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.filter(item => typeof item === 'string');
        return typeof parsed === 'string' && parsed ? [parsed] : [];
    } catch {
        return [value];
    }
};

const Chat = () => {
    const { id: chatId } = useParams();
    const [loadingMessages, setLoadingMessages] = useState(true);
    const [loadingSendMessage, setLoadingSendMessage] = useState(true);
    const [end, setEnd] = useState(false);
    const { token, user } = useAuth();
    const [chatSelected, setChatSelected] = useState<ChatType | null>(null);
    const [members, setMembers] = useState<ChatType[] | null>(null);
    const [isFocusText, setIsFocusText] = useState(false);
    const [messages, setMessages] = useState<MessageChat[]>([]);
    const { setMessage } = useMessage();
    const [page, setPage] = useState(1);
    const [isDrop, setIsDrop] = useState(false);
    const [text, setText] = useState("");
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const aiLimitBannerName = useAiMentionLimitBanner(text, user?.id);
    const buttonRef = useRef<HTMLDivElement | null>(null);
    const minHeight = 38 // Altura mínima inicial
    const navigate = useNavigate();
    const [idCommentEdit, setIdCommentEdit] = useState<MessageChat | null> (null);
    const [isEdditing, setIsEdditing] = useState(false);
    const [isFirstLoading, setIsFirstLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDeleteMessage, setIsLoadingDeleteMessage] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const { checkAndTrigger } = useThemeEffects();
    const [showConfirmationDeleteMessage, setShowConfirmationDeleteMessage] = useState(false);
    const [showConfirmationDeleteMessageForAll, setShowConfirmationDeleteMessageForAll] = useState(false);
    const [showConfirmDeleteRequest, setShowConfirmDeleteRequest] = useState(false);
    const [showConfirmClearConversation, setShowConfirmClearConversation] = useState(false);
    const [isClearingConversation, setIsClearingConversation] = useState(false);
    const [showHeaderMenu, setShowHeaderMenu] = useState(false);
    const [chatMenuInitialTab, setChatMenuInitialTab] = useState<"nickname" | "media" | "search" | "favorites" | null>(null);
    const [groupInfoInitialTab, setGroupInfoInitialTab] = useState<"media" | "search" | "favorites" | null>(null);
    const headerMenuRef = useRef<HTMLDivElement | null>(null);
    const [showForwardModal, setShowForwardModal] = useState(false);
    const [password, setPassword] = useState(''); // Adicione um estado para a senha
    const closeDeleteMessage = useRef<HTMLButtonElement | null>(null);
    const [loadingIAResponse, setLoadingIAResponse] = useState(false);
    const [idCurrentIAResponse, setIdCurrentIAResponse] = useState<number | null>(null);
    const controllerRef = useRef<AbortController | null>(null);
    const rowChatRef = useRef<HTMLDivElement>(null); //ref para scroll
    const messagesContentRef = useRef<HTMLDivElement>(null);
    const endChatRef = useRef<HTMLDivElement>(null);
    const initialScrollDone = useRef(false);
    const atBottomRef = useRef(true);
    const [showScrollToBottom, setShowScrollToBottom] = useState(false);
    const [recording, setRecording] = useState(false);
    const [audioURL, setAudioURL] = useState<string | null>(null);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunksRef = useRef<Blob[]>([]);
    const [recordingTime, setRecordingTime] = useState(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const chatContent = useRef<HTMLDivElement>(null);
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<FilePreview[]>([]);
    const [showImagePreview, setShowImagePreview] = useState(false);
    const [imagePreviewCaption, setImagePreviewCaption] = useState("");
    const fileInputRef = useRef<HTMLInputElement>(null);
    const cameraInputRef = useRef<HTMLInputElement>(null);
    const [selectedMembers, setSelectedMembers] = useState<number[]>([]);
    const [selectedMessages, setSelectedMessages] = useState<number[]>([]);
    const [showCreateGroup, setShowCreateGroup] = useState(false);
    const [showNewConversation, setShowNewConversation] = useState(false);
    const [showGroupInfo, setShowGroupInfo] = useState(false);
    const [showChatMenu, setShowChatMenu] = useState(false);
    const [replyingTo, setReplyingTo] = useState<MessageChat | null>(null);
    const [expandedMessages, setExpandedMessages] = useState<number[]>([]);
    const longPressTimer = useRef<NodeJS.Timeout | null>(null);
    const [isLongPress, setIsLongPress] = useState(false);
    const longPressTime = 500;
    const [startPosition, setStartPosition] = useState<{ x: number; y: number } | null>(null);
    const moveThreshold = 10; // px
    const [bottomPadding, setBottomPadding] = useState(0);
    const [topPadding, setTopPadding] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const [highlightedMessageId, setHighlightedMessageId] = useState<number | null>(null);
    const [openDropdown, setOpenDropdown] = useState<number | null>(null);
    const closeDropdown = () => setOpenDropdown(null);
    const [imgPath, setImgPath] = useState("");
    const [openImage, setOpenImage] = useState<string | null>(null);
    const [isScrolling, setIsScrolling] = useState(false);
    const [showEmoji, setShowEmoji] = useState(false);
    const scrollTimerRef = useRef<NodeJS.Timeout | null>(null);
    const [textareaHeight, setTextareaHeight] = useState(30);
    const [selectedIa, setSelectedIa] = useState<User>(ias[0]);
    const [showAiLimitBanner, setShowAiLimitBanner] = useState(isAiLimitReached(selectedIa.id == 2 ? "bochecha" : "pacoca", user?.id));
    useEffect(() => {
        setShowAiLimitBanner(isAiLimitReached(selectedIa.id === 2 ? "bochecha" : "pacoca", user?.id));
    }, [selectedIa.id, user?.id]);
    // ── AI conversation history ───────────────────────────────────────────────
    const [aiConversations, setAiConversations] = useState<AiConversation[]>(() =>
        loadConversations(user?.id)
    );
    // activeConvId is derived from the URL: if chatId starts with "ia-" it IS the conv id
    const [activeConvId, setActiveConvId] = useState<string | null>(() =>
        chatId && isAiConvId(chatId) ? chatId : null
    );
    const [showAiConvList, setShowAiConvList] = useState(false);
    // Refs for unmount cleanup (avoid stale closure)
    const activeConvIdRef = useRef(activeConvId);
    useEffect(() => { activeConvIdRef.current = activeConvId; }, [activeConvId]);
    const userIdRef = useRef(user?.id);
    useEffect(() => { userIdRef.current = user?.id; }, [user?.id]);
    // chatSelectedRef — keeps WS handler and polling callbacks stale-free
    const chatSelectedRef = useRef(chatSelected);
    useEffect(() => { chatSelectedRef.current = chatSelected; }, [chatSelected]);

    // Changing chats can leave multiple HTTP requests in flight. Keep a route
    // version and abort controllers so a slower response from the previous chat
    // can never overwrite the chat that is currently open.
    const chatIdRef = useRef(chatId);
    const chatLoadVersionRef = useRef(0);
    const chatDetailsAbortControllerRef = useRef<AbortController | null>(null);
    const messagesAbortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        chatIdRef.current = chatId;
        chatLoadVersionRef.current += 1;
        chatDetailsAbortControllerRef.current?.abort();
        chatDetailsAbortControllerRef.current = null;
        messagesAbortControllerRef.current?.abort();
        messagesAbortControllerRef.current = null;

        // Clear the previous chat immediately. Otherwise its header/messages
        // remain visible while the new route is being resolved.
        setChatSelected(null);
        setMessages([]);
        setPage(1);
        setEnd(false);
        initialScrollDone.current = false;
        atBottomRef.current = true;
        setShowScrollToBottom(false);
        setLoadingMessages(Boolean(chatId && !isAiConvId(chatId)));
    }, [chatId]);

    useEffect(() => () => {
        chatDetailsAbortControllerRef.current?.abort();
        messagesAbortControllerRef.current?.abort();
    }, []);

    // Track current chat-list tab so the WS handler never overwrites the principal cache
    // when the user is on the "pending" (Solicitações) tab.
    const chatListTabRef = useRef<string>("principal");
    // Poll timer refs for AI-mention fallback
    const aiPollTimersRef = useRef<NodeJS.Timeout[]>([]);
    // ─────────────────────────────────────────────────────────────────────────

    const [recordingLocked, setRecordingLocked] = useState(false);
    const [micDragX, setMicDragX] = useState(0);
    const [micDragY, setMicDragY] = useState(0);
    const [micPressing, setMicPressing] = useState(false);
    const micStartPosRef = useRef<{ x: number; y: number } | null>(null);
    const micDragXRef = useRef(0); // ref para evitar closure stale
    const micDragYRef = useRef(0);

    const aiSuggestions = useMemo(() => {
        const all = t("pacocaAI.aiSuggestions", { returnObjects: true }) as string[];
        return [...all].sort(() => Math.random() - 0.5).slice(0, 4);
    }, [t]);

    const isExpanded = (id: number) => expandedMessages?.includes(id);

    const toggleExpand = (id: number) => {
        setExpandedMessages(prev =>
            prev.includes(id) ? prev.filter(mid => mid !== id) : [...prev, id]
        );
    };


    useEffect(() => {
        if (!showHeaderMenu) return;
        const handleOutside = (e: MouseEvent) => {
            if (headerMenuRef.current && !headerMenuRef.current.contains(e.target as Node)) {
                setShowHeaderMenu(false);
            }
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, [showHeaderMenu]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            hljs.highlightAll();
        }, 20);
        return () => clearTimeout(timeout);
    }, [messages.length]);

    useEffect(() => {
        // if(m.text.includes('language')){
             const interval = setInterval(() => {
                 hljs.highlightAll();
            }, 20); // roda a cada 20ms
    
            return () => clearInterval(interval); // limpa ao desmontar
        // }
        
    }, [messages.length, isExpanded]);

    useEffect(() => {
        const handleKeyboardHeightChange = () => {
            const heightKeyboard = getNativeKeyboardHeight();
            const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;

            setBottomPadding(heightKeyboard ? heightKeyboard + nativeNavigationHeight : nativeNavigationHeight);
        };

        window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

        return () => {
            window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
        };
    }, []);
    function ajustaNewApp() {
        if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
            const nativeNavigationHeight = getNativeNavigationHeight();
            const heightKeyboard = getNativeKeyboardHeight();

            if(nativeNavigationHeight && nativeNavigationHeight > 0){
                setBottomPadding(nativeNavigationHeight + (heightKeyboard ? 20 : 0));
            }

            window.addEventListener("navigationBarHeightChange", ajustaNewApp);
            return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
        }
    }
    useEffect(() => {
        ajustaNewApp()
    }, []);

    useEffect(() => {
        const onResize = () => {
            const visualViewport = window.visualViewport;
            const heightKeyboard = getNativeKeyboardHeight();
            if(!isFocusText) {
                setTopPadding(0);
            }

            if(!heightKeyboard) {
                ajustaNewApp();
            };

            if (!visualViewport) return;

            const offsetTop = visualViewport.offsetTop;
            const offsetBottom = window.innerHeight - visualViewport.height - offsetTop;

            // Só atualiza se houver diferença real (evita re-renders desnecessários)
            if(isFocusText){
                setTopPadding(0);
                // setTopPadding(prev => (prev !== offsetTop ? (offsetTop > 0 ? offsetTop : 0) : prev));
            }

            if(heightKeyboard){
                setBottomPadding(prev => (prev !== offsetBottom ? (offsetBottom > 0 ? offsetBottom : 0) : prev));
            }
        };

        const viewport = window.visualViewport;
        viewport?.addEventListener("resize", onResize);
        viewport?.addEventListener("scroll", onResize);

        // Executa uma vez inicial
        onResize();

        return () => {
            viewport?.removeEventListener("resize", onResize);
            viewport?.removeEventListener("scroll", onResize);
        };
    }, []);

    const isTextLong = (text: string) => {
        const maxChars = 300;
        const maxLines = 10;
        const lines = text.split('\n').length;
        return text.length > ( maxChars + 200) || lines > maxLines;
    };

    const toggleSelectMessage = (id: number) => {
        setSelectedMessages(prev =>
            prev.includes(id) ? prev.filter(mid => mid !== id) : [...prev, id]
        );
    };

    const copyText = (text: string) => {
        navigator.clipboard.writeText(text);
        setMessage(t("chat.textCopied"), "success");
        setSelectedMessages([]);
    };

        // Adicione esta função para detectar scroll
    const handleScroll = useCallback(() => {
        setIsScrolling(true);
        
        // Limpa qualquer timer existente
        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }
        
        // Reseta o estado de scrolling após um curto período
        if (scrollTimerRef.current) {
            clearTimeout(scrollTimerRef.current);
        }
        
        scrollTimerRef.current = setTimeout(() => {
            setIsScrolling(false);
        }, 100);
    }, []);

    useEffect(() => {
        const container = document.querySelector('.seu-container-de-scroll'); // Substitua pelo seu seletor
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [handleScroll]);

    // Pressionar por 500ms = long press
    const onPressStart = (id: number, type: "mouse" | "touch", e: any) => {
        if (type == "mouse" && window.innerWidth <= 850) return;
        if(isFocusText) return;
        
        // Se estiver rolando, não inicia o long press
        if (isScrolling) {
            return;
        }
        
        setIsLongPress(false);
        setIsScrolling(false);

        // Salva posição inicial e o elemento
        const clientX = type === "touch" ? e.touches[0].clientX : e.clientX;
        const clientY = type === "touch" ? e.touches[0].clientY : e.clientY;
        setStartPosition({ x: clientX, y: clientY });

        longPressTimer.current = setTimeout(() => {
            toggleSelectMessage(id);
            setIsLongPress(true);
        }, longPressTime);
    };

    // Modifique o onPressEnd
    const onPressEnd = (id: number, type: "mouse" | "touch", e: any) => {
        if (type === "mouse" && window.innerWidth <= 850) return;
        if(isFocusText) return;

        // Se estiver rolando, ignora completamente
        if (isScrolling) {
            return;
        }

        if (longPressTimer.current) {
            clearTimeout(longPressTimer.current);
            longPressTimer.current = null;
        }

        // Checa movimento (aumente um pouco o threshold para scroll)
        if (startPosition) {
            const clientX = type === "touch" ? e.changedTouches[0].clientX : e.clientX;
            const clientY = type === "touch" ? e.changedTouches[0].clientY : e.clientY;

            const dx = Math.abs(clientX - startPosition.x);
            const dy = Math.abs(clientY - startPosition.y);

            // Aumente o threshold para ser mais tolerante
            if (dx > 15 || dy > 15) { // ou ajuste conforme necessário
                // Moveu muito => provavelmente scroll, não seleciona
                return;
            }
        }

        if (!isLongPress) {
            // clique curto
            if (selectedMessages.length > 0) {
                toggleSelectMessage(id);
            }
        }
    };

    // Adicione também um onMouseMove/onTouchMove para cancelar o timer se houver movimento
    const onPressMove = (e: any, type: "mouse" | "touch") => {
        if (!startPosition || !longPressTimer.current) return;
        
        const clientX = type === "touch" ? e.touches[0].clientX : e.clientX;
        const clientY = type === "touch" ? e.touches[0].clientY : e.clientY;
        
        const dx = Math.abs(clientX - startPosition.x);
        const dy = Math.abs(clientY - startPosition.y);
        
        // Se mover além do threshold, cancela o long press
        if (dx > 10 || dy > 10) {
            if (longPressTimer.current) {
                clearTimeout(longPressTimer.current);
                longPressTimer.current = null;
            }
        }
    };
    
    useEffect(() => {
        if(isEdditing){
            textareaRef.current?.focus();
        }
    }, [selectedMessages, isEdditing])

    useEffect(() => {
        if(replyingTo){
            textareaRef.current?.focus();
        }
    }, [replyingTo])

    const getImagePath = (path: string) => {
        if(path.includes("http://") || path.includes("https://") || path.includes("blob"))
            return path;
    
        return BUCKET_PACOCA_URL + "/" + path;
    };
    

    const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;

        const fileArray = Array.from(files).slice(0, 10);
        const previews = fileArray.map((file) => ({
            file,
            src: URL.createObjectURL(file),
        }));

        const hasMedia = previews.some(p => p.file.type.startsWith("image") || p.file.type.startsWith("video"));
        setSelectedFiles(previews);
        if (hasMedia) {
            setImagePreviewCaption("");
            setShowImagePreview(true);
        }
    };

    const removeFile = (index: number) => {
        setSelectedFiles(prev => {
            const updated = prev.filter((_, i) => i !== index);
            if (updated.length === 0) setShowImagePreview(false);
            return updated;
        });
    };

    const cancelRecording = () => {
        if (timerRef.current) clearInterval(timerRef.current);
        setRecordingTime(0);
        setRecording(false);
        stopRecordingPresence();
        setRecordingLocked(false);
        setMicPressing(false);
        setMicDragX(0);
        setMicDragY(0);
        micDragXRef.current = 0;
        micDragYRef.current = 0;
        micStartPosRef.current = null;

        if (hasNativeMic()) {
            (window as any).ReactNativeWebView.postMessage(
                JSON.stringify({ type: "stopRecording", send: false })
            );
            return;
        }
        if (!mediaRecorderRef.current) return;
        mediaRecorderRef.current.onstop = () => { audioChunksRef.current = []; };
        mediaRecorderRef.current.stop();
        mediaRecorderRef.current.stream.getTracks().forEach(t => t.stop());
    };

    const handleMicTouchStart = (e: React.TouchEvent) => {
        if (recording && recordingLocked) return;
        e.preventDefault();
        const touch = e.touches[0];
        micStartPosRef.current = { x: touch.clientX, y: touch.clientY };
        micDragXRef.current = 0;
        micDragYRef.current = 0;
        setMicDragX(0);
        setMicDragY(0);
        setMicPressing(true);
        startRecording();
    };

    const handleMicTouchMove = (e: React.TouchEvent) => {
        if (!micStartPosRef.current || !recording || recordingLocked) return;
        const touch = e.touches[0];
        const dx = Math.min(0, touch.clientX - micStartPosRef.current.x);
        const dy = Math.min(0, touch.clientY - micStartPosRef.current.y);

        micDragXRef.current = dx;
        micDragYRef.current = dy;
        setMicDragX(dx);
        setMicDragY(dy);

        // Arrastar para cima → travar gravação
        if (dy < -80) {
            setRecordingLocked(true);
            setMicPressing(false);
            micDragXRef.current = 0;
            micDragYRef.current = 0;
            setMicDragX(0);
            setMicDragY(0);
            micStartPosRef.current = null;
        }
    };

    const handleMicTouchEnd = () => {
        if (!micPressing) return;
        setMicPressing(false);
        micStartPosRef.current = null;

        const dragX = micDragXRef.current;
        micDragXRef.current = 0;
        micDragYRef.current = 0;
        setMicDragX(0);
        setMicDragY(0);

        if (dragX < -80) {
            cancelRecording(); // Arrastou para esquerda → cancelar
        } else if (!recordingLocked) {
            stopRecording(true); // Soltou sem arrastar → enviar
        }
    };

    useEffect(() => {
        const handleNativeAudio = (event: MessageEvent) => {
            try {
                const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;

                if (data.type === "audioRecorded") {
                    // Converte base64 → Blob
                    const binary = atob(data.base64);
                    const bytes = new Uint8Array(binary.length);
                    for (let i = 0; i < binary.length; i++) {
                        bytes[i] = binary.charCodeAt(i);
                    }
                    const mimeType = data.mimeType || "audio/mp4";
                    const blob = new Blob([bytes], { type: mimeType });

                    if (data.send) {
                        handleSubmitAudioMessage(blob, mimeType);
                    }
                }

                if (data.type === "recordingError") {
                    setMessage(data.message || t("chat.errorRecordAudio"), "error");
                    setRecording(false);
                    stopRecordingPresence();
                    if (timerRef.current) clearInterval(timerRef.current);
                    setRecordingTime(0);
                }
            } catch (e) {
                // ignora mensagens não relacionadas
            }
        };

        window.addEventListener("message", handleNativeAudio);
        return () => window.removeEventListener("message", handleNativeAudio);
    }, [chatSelected, messages]);

    // ─── startRecording ───────────────────────────────────────────────────────────
    const startRecording = async () => {
        // Inicia o timer visual independente de onde grava
        timerRef.current = setInterval(() => {
            setRecordingTime((prev) => prev + 1);
        }, 1000);
        setRecording(true);
        startRecordingPresence();

        // ── WebView nativo: delega para o React Native ──
        if (hasNativeMic()) {
            (window as any).ReactNativeWebView.postMessage(
                JSON.stringify({ type: "startRecording" })
            );
            return;
        }

        // ── Browser normal: usa getUserMedia ──
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            const mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
                ? "audio/webm;codecs=opus"
                : MediaRecorder.isTypeSupported("audio/webm")
                ? "audio/webm"
                : MediaRecorder.isTypeSupported("audio/mp4")
                ? "audio/mp4"
                : "audio/ogg";

            mediaRecorderRef.current = new MediaRecorder(stream, { mimeType });
            audioChunksRef.current = [];

            mediaRecorderRef.current.ondataavailable = (e) => {
                if (e.data.size > 0) audioChunksRef.current.push(e.data);
            };

            mediaRecorderRef.current.onstop = () => {
                const blob = new Blob(audioChunksRef.current, { type: mimeType });
                setAudioURL(URL.createObjectURL(blob));
            };

            mediaRecorderRef.current.start();
        } catch (err) {
            setMessage(t("chat.microphoneError"), "error");
            setRecording(false);
            stopRecordingPresence();
            if (timerRef.current) clearInterval(timerRef.current);
            setRecordingTime(0);
        }
    };

    // ─── stopRecording ────────────────────────────────────────────────────────────
    const stopRecording = (send = false) => {
        if (timerRef.current) clearInterval(timerRef.current);
        setRecordingTime(0);
        setRecording(false);
        stopRecordingPresence();

        // ── WebView nativo: delega para o React Native ──
        if (hasNativeMic()) {
            (window as any).ReactNativeWebView.postMessage(
                JSON.stringify({ type: "stopRecording", send })
            );
            return;
        }

        // ── Browser normal ──
        if (!mediaRecorderRef.current) return;

        const mimeType = mediaRecorderRef.current.mimeType;

        mediaRecorderRef.current.onstop = async () => {
            const blob = new Blob(audioChunksRef.current, { type: mimeType });
            setAudioURL(URL.createObjectURL(blob));
            if (send) {
                setTimeout(() => handleSubmitAudioMessage(blob, mimeType), 50);
            }
        };

        mediaRecorderRef.current.stop();
        mediaRecorderRef.current.stream.getTracks().forEach((t) => t.stop());
    };

    // ─── handleSubmitAudioMessage — aceita mimeType opcional ─────────────────────
    const handleSubmitAudioMessage = async (blob: Blob, mimeType?: string) => {
        if (!blob || !chatSelected) return;

        const resolvedMime = mimeType || blob.type || "audio/webm";
        const extension = resolvedMime.includes("mp4") || resolvedMime.includes("m4a")
            ? "m4a"
            : resolvedMime.includes("ogg") ? "ogg" : "webm";

        const audioURL = URL.createObjectURL(blob);
        const tempId = Date.now();

        const newMessageData = {
            id: Number(tempId),
            idNotSend: true,
            user_id: Number(user?.id),
            user: user as User,
            created_at: new Date().toISOString(),
            chat_id: Number(chatSelected?.chat_id),
            text: "",
            file_path: JSON.stringify([audioURL]),
            file_type: JSON.stringify([resolvedMime]),
        };

        setMessages((prev) => {
            const updated = [...prev, newMessageData];
            const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
            const map: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
            map[chatSelected.chat_id] = updated;
            localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(map));
            return updated;
        });

        const formData = new FormData();
        formData.append("chat_id", String(chatSelected.chat_id));
        formData.append("file[]", blob, `audio.${extension}`);

        try {
            const response = await axios.post(`${PACOCA_API_URL}/chats/messages`, formData, {
                headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
            });

            setMessages((prev) => {
                const updated = prev.map((m) =>
                    m.id === tempId ? { ...m, id: response?.data?.message?.id, idNotSend: false } : m
                );
                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                const map: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                map[chatSelected.chat_id] = updated;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(map));
                return updated;
            });

            scrollToBottom(false);
            setAudioURL("");
        } catch (err) {
            console.error("Erro ao enviar áudio:", err);
        }
    };

    // const startRecording = async () => {
    //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    //     if(!mediaRecorderRef || !stream) return;

    //     timerRef.current = setInterval(() => {
    //         setRecordingTime((prev) => prev + 1);
    //     }, 1000);

    //     mediaRecorderRef.current = new MediaRecorder(stream);

    //     audioChunksRef.current = [];

    //     mediaRecorderRef.current.ondataavailable = event => {
    //         if (event.data.size > 0) {
    //             audioChunksRef.current.push(event.data);
    //         }
    //     };

    //     mediaRecorderRef.current.onstop = () => {
    //         const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    //         const url = URL.createObjectURL(blob);
    //         setAudioURL(url);
    //     };

    //     mediaRecorderRef.current.start();
    //     setRecording(true);
    // };

    const formatTime = (seconds: number) => {
        const min = String(Math.floor(seconds / 60)).padStart(2, "0");
        const sec = String(seconds % 60).padStart(2, "0");
        return `${min}:${sec}`;
    };

    // const stopRecording = (send = false) => {
    //     if (!mediaRecorderRef.current) return;

    //     // Adiciona o manipulador antes de parar
    //     mediaRecorderRef.current.onstop = async () => {
    //         const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    //         const url = URL.createObjectURL(blob);
    //         setAudioURL(url);
    //         if (timerRef.current) {
    //             clearInterval(timerRef.current);
    //         }
    //         setRecordingTime(0);

    //         setRecording(false);

    //         if (send) {
    //             // Aguarda um pequeno tempo para garantir que o audioURL esteja setado
    //             setTimeout(() => {
    //                 handleSubmitAudioMessage(blob);
    //             }, 50);
    //         }
    //     };

    //     mediaRecorderRef.current.stop();
    //     mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
    // };

    const onCloseDeleteMessage = () => {
        setPassword("");
        setShowConfirmationDeleteMessage(false);
    }

    const onCloseDeleteMessageForAll = () => {
        setPassword("");
        setShowConfirmationDeleteMessageForAll(false);
    }

    const scrollToMessage = (id: number) => {
        const container = rowChatRef.current;
        const el = document.getElementById(`msg-${id}`);
        if (!el || !container) return;
        const containerRect = container.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const offset = elRect.top - containerRect.top - container.clientHeight / 2 + el.clientHeight / 2;
        container.scrollTop += offset;
        setHighlightedMessageId(id);
        setTimeout(() => setHighlightedMessageId(null), 2500);
    };

    // Scroll para mensagem específica ao abrir chat via pesquisa
    useEffect(() => {
        const targetId = searchParams.get("message");
        if (!targetId || messages.length === 0 || loadingMessages) return;

        const id = Number(targetId);
        scrollToMessage(id);
    }, [messages, loadingMessages]);

    const updateScrollToBottomVisibility = useCallback(() => {
        const container = rowChatRef.current;
        if (!container) return false;

        const isAtBottom = isNearScrollBottom(container);
        atBottomRef.current = isAtBottom;
        setShowScrollToBottom(current => {
            const next = !isAtBottom;
            return current === next ? current : next;
        });
        return isAtBottom;
    }, []);

    const scrollToBottomAfterLayout = useCallback((behavior: ScrollBehavior = 'auto') => {
        const container = rowChatRef.current;
        if (!container) return;
        container.scrollTo({ top: container.scrollHeight, behavior });
    }, []);

    // Posiciona no fim somente depois que a carga inicial terminou e o conteúdo
    // foi renderizado. O parâmetro `message` continua abrindo no ponto pesquisado.
    useEffect(() => {
        if (loadingMessages || !chatSelected || searchParams.get("message")) return;
        if (initialScrollDone.current) return;

        initialScrollDone.current = true;
        atBottomRef.current = true;
        scrollToBottomAfterLayout();
    }, [chatSelected, loadingMessages, messages.length, searchParams, scrollToBottomAfterLayout]);

    // Mantém o usuário no fim quando novas mensagens chegam, mas não interrompe
    // quem já está lendo mensagens antigas.
    useEffect(() => {
        if (loadingMessages || searchParams.get("message") || !initialScrollDone.current) return;
        if (atBottomRef.current) scrollToBottomAfterLayout();
    }, [messages, loadingMessages, searchParams, scrollToBottomAfterLayout]);

    useEffect(() => {
        const container = rowChatRef.current;
        const content = messagesContentRef.current;
        if (!container || !content || typeof ResizeObserver === 'undefined') return;

        let frame = 0;
        const syncAfterLayout = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                if (atBottomRef.current) {
                    container.scrollTo({ top: container.scrollHeight, behavior: 'auto' });
                }
                updateScrollToBottomVisibility();
            });
        };
        const observer = new ResizeObserver(syncAfterLayout);
        observer.observe(container);
        observer.observe(content);
        syncAfterLayout();

        return () => {
            cancelAnimationFrame(frame);
            observer.disconnect();
        };
    }, [chatSelected?.chat_id, loadingMessages, messages.length, updateScrollToBottomVisibility]);

    const scrollToBottom = (validateNearBottom = true) => {
        const isAtBottom = updateScrollToBottomVisibility();
        if (!validateNearBottom || isAtBottom) {
            atBottomRef.current = true;
            scrollToBottomAfterLayout();
        }
    };


    useEffect(() => {
        if(!chatId || !location.pathname.includes("/chat/") || (chatId && isAiConvId(chatId))) setLoadingMessages(false)
    }, [chatId]);

    useEffect(() => {
        const root = document.getElementById("navbar-pc");
        const menuMobile = document.getElementById("small-menu-top");

        if (root) root.style.display = "none";
        if (menuMobile) menuMobile.style.display = "none";

        return () => {
            if (root) root.style.display = "block"; // Restaura ao desmontar
            if (menuMobile) menuMobile.style.display = "block"; // Restaura ao desmontar
            // Clear any pending AI reply poll timers
            aiPollTimersRef.current.forEach(clearTimeout);
            aiPollTimersRef.current = [];
        };
    }, []);


    const loadChatById = async () => {
        const requestedChatId = chatId;
        if (!requestedChatId || !location.pathname.includes("/chat/")) return;
        // AI conversations are handled by the AI URL routing effect — skip here
        if (isAiConvId(requestedChatId)) return;

        const requestVersion = chatLoadVersionRef.current;
        const isCurrentRequest = () =>
            chatLoadVersionRef.current === requestVersion &&
            chatIdRef.current === requestedChatId;
        const isCanceled = (err: unknown, controller?: AbortController) =>
            controller?.signal.aborted || axios.isCancel(err) || (err as any)?.code === "ERR_CANCELED";

        let chat: ChatType | undefined;

        // Se começar com "@", procura pelo user_name
        if (requestedChatId.startsWith("@")) {
            if (requestedChatId === "@pacoca_ai") {
                if (isCurrentRequest()) {
                    window.location.href = "/chat";
                    setChatSelected(null);
                }
                return;
            }

            chat = members?.find(item => item.user_name === requestedChatId.replace("@", ""));
            if (chat) {
                if (!isCurrentRequest()) return;
                setMessages([]);
                setPage(1);
                setChatSelected(chat);
                return;
            }

            const controller = new AbortController();
            chatDetailsAbortControllerRef.current = controller;
            try {
                const url = `${PACOCA_API_URL}/chats`;
                const response = await api(token).post(url, {
                    user_name: requestedChatId.replace("@", "")
                }, { signal: controller.signal });

                if (!isCurrentRequest()) return;

                const data = response.data;
                setMessages([]);
                setPage(1);
                setChatSelected(data);
                if (searchParams.get("adicionar-principal")) {
                    setMembers(prev => {
                        if (prev) {
                            const exists = prev.find(item => item.chat_id === data.chat_id);
                            if (!exists) {
                                const updated = [data, ...prev];
                                localStorage.setItem(getChatListCacheKey(user?.id), JSON.stringify(updated));
                                return updated;
                            }
                        }
                        return prev;
                    });

                    navigate(`/chat/@${data.user_name}`, { replace: true });
                }
            } catch (err: any) {
                if (!isCurrentRequest() || isCanceled(err, controller)) return;
                const messageError = errorMessage(err);
                setLoadingMessages(false);
                setMessage(messageError, "error");
                console.error(err);
                console.error(messageError);
            } finally {
                if (chatDetailsAbortControllerRef.current === controller) {
                    chatDetailsAbortControllerRef.current = null;
                }
            }
            return;
        }

        chat = members?.find(item => item.chat_id === Number(requestedChatId));

        // For 1-on-1 chats found locally, redirect by username (no API call needed)
        if (chat && !chat.is_group) {
            if (isCurrentRequest()) {
                navigate(`/chat/@${chat.user_name}`, { replace: true });
            }
            return;
        }

        // Always fetch fresh data for group chats (ensures is_community_chat / community_id are current)
        const controller = new AbortController();
        chatDetailsAbortControllerRef.current = controller;
        try {
            const url = `${PACOCA_API_URL}/chats/${requestedChatId}`;
            const response = await api(token).get(url, { signal: controller.signal });

            if (!isCurrentRequest()) return;

            const data = response.data.members;
            setMessages([]);
            setPage(1);
            if (data.is_group) {
                setChatSelected(data);
            } else {
                navigate(`/chat/@${data.user_name}`, { replace: true });
            }
        } catch (err: any) {
            if (!isCurrentRequest() || isCanceled(err, controller)) return;
            const messageError = errorMessage(err);
            setLoadingMessages(false);
            setMessage(messageError, "error");
            console.error(err);
            console.error(messageError);
        } finally {
            if (chatDetailsAbortControllerRef.current === controller) {
                chatDetailsAbortControllerRef.current = null;
            }
        }
    };

    const membersRef = useRef(members);
    useEffect(() => { membersRef.current = members; }, [members]);

    useEffect(() => {
        // The list starts as null and is populated asynchronously. Resolve the
        // route once it becomes available, but do not re-resolve on every list
        // update (that used to restart the chat and create request races).
        if (membersRef.current !== null) loadChatById();
    }, [chatId, members !== null]);

    useEffect(() => {
        if (user?.read_receipts_enabled !== false || !user?.id) return;
        setMessages(prev => prev.map(message =>
            message.user_id === user.id ? { ...message, is_read: false } : message
        ));
    }, [user?.id, user?.read_receipts_enabled]);

    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const readReceiptTimerRef = useRef<NodeJS.Timeout | null>(null);
    const pendingReadMessageIdRef = useRef<number | null>(null);
    const lastReadMessageIdRef = useRef<number>(0);
    const [typingUsers, setTypingUsers] = useState<Record<number, ChatPresenceUser>>({});
    const typingTimeoutsRef = useRef<Record<number, NodeJS.Timeout>>({});
    const typingHeartbeatRef = useRef<NodeJS.Timeout | null>(null);
    const typingChatIdRef = useRef<number | null>(null);
    const typingActiveRef = useRef(false);
    const typingStopTimerRef = useRef<NodeJS.Timeout | null>(null);
    const [recordingUsers, setRecordingUsers] = useState<Record<number, ChatPresenceUser>>({});
    const recordingTimeoutsRef = useRef<Record<number, NodeJS.Timeout>>({});
    const recordingHeartbeatRef = useRef<NodeJS.Timeout | null>(null);
    const recordingChatIdRef = useRef<number | null>(null);
    const recordingActiveRef = useRef(false);
    const recordingStopTimerRef = useRef<NodeJS.Timeout | null>(null);

    const sendTypingSignal = (chatIdToSignal: number, isTyping: boolean) => {
        if (!token) return;
        api(token).post('/chats/messages/typing', {
            chat_id: chatIdToSignal,
            is_typing: isTyping,
        }).catch(() => {
            // Typing state is best effort and must never interrupt composition.
        });
    };

    const stopTypingIndicator = () => {
        if (typingStopTimerRef.current) clearTimeout(typingStopTimerRef.current);
        if (typingHeartbeatRef.current) clearInterval(typingHeartbeatRef.current);
        typingStopTimerRef.current = null;
        typingHeartbeatRef.current = null;
        if (typingActiveRef.current && typingChatIdRef.current) {
            sendTypingSignal(typingChatIdRef.current, false);
        }
        typingActiveRef.current = false;
        typingChatIdRef.current = null;
    };

    const scheduleTypingIndicator = (value: string) => {
        const currentChatId = chatSelectedRef.current?.chat_id;
        if (!currentChatId || !value.trim() || isAiConvId(String(currentChatId))) {
            stopTypingIndicator();
            return;
        }

        if (typingChatIdRef.current !== currentChatId) {
            stopTypingIndicator();
            typingChatIdRef.current = currentChatId;
        }

        if (!typingActiveRef.current) {
            typingActiveRef.current = true;
            sendTypingSignal(currentChatId, true);
            typingHeartbeatRef.current = setInterval(() => {
                if (typingActiveRef.current && typingChatIdRef.current) {
                    sendTypingSignal(typingChatIdRef.current, true);
                }
            }, 1500);
        }

        if (typingStopTimerRef.current) clearTimeout(typingStopTimerRef.current);
        typingStopTimerRef.current = setTimeout(stopTypingIndicator, 2400);
    };

    const sendRecordingSignal = (chatIdToSignal: number, isRecording: boolean) => {
        if (!token) return;
        api(token).post('/chats/messages/recording-audio', {
            chat_id: chatIdToSignal,
            is_recording: isRecording,
        }).catch(() => {
            // Audio recording state is best effort.
        });
    };

    const stopRecordingPresence = () => {
        if (recordingStopTimerRef.current) clearTimeout(recordingStopTimerRef.current);
        if (recordingHeartbeatRef.current) clearInterval(recordingHeartbeatRef.current);
        recordingStopTimerRef.current = null;
        recordingHeartbeatRef.current = null;
        if (recordingActiveRef.current && recordingChatIdRef.current) {
            sendRecordingSignal(recordingChatIdRef.current, false);
        }
        recordingActiveRef.current = false;
        recordingChatIdRef.current = null;
    };

    const startRecordingPresence = () => {
        const currentChatId = chatSelectedRef.current?.chat_id;
        if (!currentChatId || isAiConvId(String(currentChatId))) return;
        recordingChatIdRef.current = currentChatId;
        if (recordingActiveRef.current) return;
        recordingActiveRef.current = true;
        sendRecordingSignal(currentChatId, true);
        recordingHeartbeatRef.current = setInterval(() => {
            if (recordingActiveRef.current && recordingChatIdRef.current) {
                sendRecordingSignal(recordingChatIdRef.current, true);

                // Refresh the safety timeout on every heartbeat. A one-shot
                // timeout here made the recording presence stop after 3.6s
                // even while the user was still recording.
                if (recordingStopTimerRef.current) clearTimeout(recordingStopTimerRef.current);
                recordingStopTimerRef.current = setTimeout(stopRecordingPresence, 4500);
            }
        }, 1800);
        recordingStopTimerRef.current = setTimeout(stopRecordingPresence, 4500);
    };

    const recordingPresenceUsers = Object.values(recordingUsers);
    const typingPresenceUsers = Object.values(typingUsers);
    const recordingUserNames = recordingPresenceUsers.map(presenceUser => presenceUser.name);
    const typingUserNames = typingPresenceUsers.map(presenceUser => presenceUser.name);

    const scheduleMarkMessagesAsRead = (chatIdToMark: number, messageId: number) => {
        if (user?.read_receipts_enabled === false || !token || !messageId) return;

        pendingReadMessageIdRef.current = Math.max(
            pendingReadMessageIdRef.current ?? 0,
            messageId
        );
        if (readReceiptTimerRef.current) clearTimeout(readReceiptTimerRef.current);

        // Coalesce bursts of incoming messages and focus events into one
        // high-water-mark request instead of one request per message.
        readReceiptTimerRef.current = setTimeout(async () => {
            const targetId = pendingReadMessageIdRef.current;
            pendingReadMessageIdRef.current = null;
            if (!targetId || targetId <= lastReadMessageIdRef.current) return;

            try {
                await api(token).post('/chats/messages/read', {
                    chat_id: chatIdToMark,
                    message_id: targetId,
                });
                lastReadMessageIdRef.current = targetId;
            } catch {
                // A later focus/message event will retry without blocking chat UI.
            }
        }, 250);
    };

    useEffect(() => () => {
        if (readReceiptTimerRef.current) clearTimeout(readReceiptTimerRef.current);
        readReceiptTimerRef.current = null;
        pendingReadMessageIdRef.current = null;
        lastReadMessageIdRef.current = 0;
    }, [chatSelected?.chat_id]);

    useEffect(() => {
        stopTypingIndicator();
        stopRecordingPresence();
        setTypingUsers({});
        setRecordingUsers({});
    }, [chatSelected?.chat_id]);

    useEffect(() => () => {
        stopTypingIndicator();
        stopRecordingPresence();
        Object.values(typingTimeoutsRef.current).forEach(clearTimeout);
        Object.values(recordingTimeoutsRef.current).forEach(clearTimeout);
    }, []);

    const messagesRef = useRef(messages);
    useEffect(() => { messagesRef.current = messages; }, [messages]);

    // IDs reais confirmados pelo HTTP — o WS rejeita esses IDs para não duplicar.
    const confirmedIdsRef = useRef<Set<number>>(new Set());

    // ── Real-time messages via WebSocket (Laravel Reverb) ─────────────────────
    // When a new message arrives for the open chat, append it to the messages list.
    // For ALL chats (open or not), also update the sidebar preview (last_message + top position).
    useChatEcho({
        userId: user?.id,
        token,
        onMessage: (chatId, message) => {
            const isCurrentChat = Number(chatSelectedRef.current?.chat_id) === Number(chatId);

            // ── 1. If it's the currently open chat, append to messages ──────────
            if (isCurrentChat) {
                setMessages(prev => {
                    // Reject if already in list (exact id) or already confirmed via HTTP
                    if (prev.find(m => m.id === message.id)) return prev;
                    if (confirmedIdsRef.current.has(message.id)) return prev;

                    // If there's still a pending optimistic sent by the current user
                    // with the same text/gif, this WS event is the echo of our own
                    // message — skip it. The HTTP response owns own-message state.
                    const hasPendingOptimistic =
                        message.user_id === userIdRef.current &&
                        prev.some(
                            m =>
                                m.idNotSend &&
                                m.chat_id === message.chat_id &&
                                m.text === message.text &&
                                (m.gif_url ?? null) === (message.gif_url ?? null)
                        );
                    if (hasPendingOptimistic) return prev;

                    const updated = [...prev, message];

                    // Persist to localStorage
                    const stored = localStorage.getItem(`messagesByChat-${userIdRef.current}`);
                    const byChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                    byChat[chatId] = updated;
                    localStorage.setItem(`messagesByChat-${userIdRef.current}`, JSON.stringify(byChat));

                    return updated;
                });
            }

            if (isCurrentChat && message.user_id !== userIdRef.current) {
                scheduleMarkMessagesAsRead(chatId, message.id);
            }

            // ── 2. Badge: if message is from another chat and not from self ──────
            if (
                !isCurrentChat &&
                message.user_id !== user?.id &&
                user?.id
            ) {
                incrementGlobalChatBadge(user.id);
            }

            // ── 3. Always update the sidebar list preview for the chat ──────────
            setMembers(prev => {
                if (!prev) return prev;
                const idx = prev.findIndex(m => m.chat_id === chatId);
                if (idx === -1) return prev;

                const serialized = JSON.stringify(message);
                const updated = [...prev];

                // Move to top so the most recent chat bubbles up
                const [chat] = updated.splice(idx, 1);
                updated.unshift({ ...chat, last_message: serialized as any });

                // Only persist the principal tab cache — never overwrite it with pending chats
                if (chatListTabRef.current === "principal") {
                    try {
                        localStorage.setItem(getChatListCacheKey(userIdRef.current), JSON.stringify(updated));
                    } catch { /* quota exceeded */ }
                }

                return updated;
            });
        },
        onRead: ({ chat_id, reader_id, message_id, read_at, is_read, read_by_count, read_by_total }) => {
            if (Number(reader_id) === Number(userIdRef.current)) return;

            const isCurrentGroup = Boolean(chatSelectedRef.current?.is_group);
            const hasReadCounts = Number.isFinite(Number(read_by_count))
                && Number.isFinite(Number(read_by_total));
            const allMembersRead = is_read === true;

            if (chatSelectedRef.current?.chat_id === chat_id) setMessages(prev => {
                const updated = prev.map(message => {
                    if (message.user_id !== userIdRef.current || message.id > message_id) {
                        return message;
                    }

                    const isSameMessage = Number(message.id) === Number(message_id);
                    return {
                        ...message,
                        // In groups, one reader must not turn every outgoing
                        // message brown. The server sends `is_read` only when
                        // all eligible members have seen the message.
                        is_read: isCurrentGroup
                            ? allMembersRead || (!isSameMessage ? message.is_read : false)
                            : is_read ?? true,
                        ...(isCurrentGroup && hasReadCounts && (isSameMessage || allMembersRead)
                            ? {
                                read_by_count: allMembersRead ? read_by_total : read_by_count,
                                read_by_total,
                            }
                            : {}),
                        ...(read_at ? { read_at } : {}),
                    };
                });
                const stored = localStorage.getItem(`messagesByChat-${userIdRef.current}`);
                const byChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                byChat[chat_id] = updated;
                localStorage.setItem(`messagesByChat-${userIdRef.current}`, JSON.stringify(byChat));
                return updated;
            });

            // Update the cached sidebar preview as soon as the read event
            // arrives. System notifications intentionally never receive a
            // delivery/read indicator.
            setMembers(prev => {
                if (!prev) return prev;
                const updated = prev.map(member => {
                    if (member.chat_id !== chat_id || !member.last_message) return member;

                    const lastMessage = typeof member.last_message === "string"
                        ? JSON.parse(member.last_message)
                        : member.last_message;
                    if (
                        !lastMessage
                        || lastMessage.message_type === "system"
                        || Number(lastMessage.user_id) !== Number(userIdRef.current)
                        || Number(lastMessage.id) > Number(message_id)
                    ) {
                        return member;
                    }

                    const isGroup = Boolean(member.is_group);
                    const isSameMessage = Number(lastMessage.id) === Number(message_id);
                    return {
                        ...member,
                        last_message: {
                            ...lastMessage,
                            is_read: isGroup
                                ? allMembersRead || (!isSameMessage ? lastMessage.is_read : false)
                                : is_read ?? true,
                            ...(isGroup && hasReadCounts && (isSameMessage || allMembersRead)
                                ? {
                                    read_by_count: allMembersRead ? read_by_total : read_by_count,
                                    read_by_total,
                                }
                                : {}),
                            ...(read_at ? { read_at } : {}),
                        },
                    } as typeof member;
                });
                try {
                    localStorage.setItem(getChatListCacheKey(userIdRef.current), JSON.stringify(updated));
                } catch { /* quota exceeded */ }
                return updated;
            });
        },
        onTyping: ({ chat_id, user_id, user_name, user_img_account, is_typing }) => {
            if (chatSelectedRef.current?.chat_id !== chat_id || user_id === userIdRef.current) return;
            const existing = typingTimeoutsRef.current[user_id];
            if (existing) clearTimeout(existing);

            if (!is_typing) {
                setTypingUsers(prev => {
                    const next = { ...prev };
                    delete next[user_id];
                    return next;
                });
                delete typingTimeoutsRef.current[user_id];
                return;
            }

            setTypingUsers(prev => ({
                ...prev,
                [user_id]: { name: user_name, imgAccount: user_img_account },
            }));
            typingTimeoutsRef.current[user_id] = setTimeout(() => {
                setTypingUsers(prev => {
                    const next = { ...prev };
                    delete next[user_id];
                    return next;
                });
                delete typingTimeoutsRef.current[user_id];
            }, 3200);
        },
        onRecording: ({ chat_id, user_id, user_name, user_img_account, is_recording }) => {
            if (chatSelectedRef.current?.chat_id !== chat_id || user_id === userIdRef.current) return;
            const existing = recordingTimeoutsRef.current[user_id];
            if (existing) clearTimeout(existing);

            if (!is_recording) {
                setRecordingUsers(prev => {
                    const next = { ...prev };
                    delete next[user_id];
                    return next;
                });
                delete recordingTimeoutsRef.current[user_id];
                return;
            }

            setRecordingUsers(prev => ({
                ...prev,
                [user_id]: { name: user_name, imgAccount: user_img_account },
            }));
            recordingTimeoutsRef.current[user_id] = setTimeout(() => {
                setRecordingUsers(prev => {
                    const next = { ...prev };
                    delete next[user_id];
                    return next;
                });
                delete recordingTimeoutsRef.current[user_id];
            }, 4000);
        },
    });

    // ── Fallback: initial load when opening a chat ────────────────────────────
    useEffect(() => {
        if (!chatSelected?.chat_id || !location.pathname.includes("/chat/")) return;
        loadMessages(1, chatSelected.chat_id);
    }, [chatSelected?.chat_id]);

    const updateText = (newText: string) => {
        setText(newText); // Atualiza o estado com o novo texto
    };

    const handleDrop = async (e: any) => {
        e.preventDefault();
        if (!e.dataTransfer?.files || e.dataTransfer.files.length === 0) return;

        const rawFiles: File[] = Array.from(e.dataTransfer.files).slice(0, 10) as File[];

        // Process all files in parallel (HEIC conversion + compression)
        const processed = await Promise.all(
            rawFiles.map(async (f) => {
                let file: any = f;
                file = await convertHeic(file);
                file = await compressImage(file);
                return file as File;
            })
        );

        const imageFiles = processed.filter(f => f.type.startsWith("image/") || f.type.startsWith("video/"));
        const otherFiles = processed.filter(f => !f.type.startsWith("image/") && !f.type.startsWith("video/"));

        // Read all image/video files to data URLs in parallel
        const imagePreviews: FilePreview[] = await Promise.all(
            imageFiles.map(file => new Promise<FilePreview>((resolve) => {
                const reader = new FileReader();
                reader.onload = (ev) => {
                    const src = ev.target?.result;
                    if (typeof src === "string") resolve({ file, src });
                };
                reader.readAsDataURL(file);
            }))
        );

        if (imagePreviews.length > 0) {
            setSelectedFiles(prev => [...prev, ...imagePreviews].slice(0, 10));
            setImagePreviewCaption("");
            setShowImagePreview(true);
        }

        // Non-media files go through the normal file input path
        otherFiles.forEach(file => handleFile(file));
    };
    
    useEffect(() => {
        const textarea = chatContent.current;
        
        if (!textarea) return;

        const handleDragOver = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            textarea.style.setProperty("border", "2px dashed #000", "important");
            textarea.style.setProperty("opacity", ".5");
            setIsDrop(true);
        };

        const handleDragLeave = (event: DragEvent) => {
            event.preventDefault();
            event.stopPropagation();
            textarea.style.border = "0";
            textarea.style.setProperty("opacity", "1");
            setIsDrop(false);
        };

        const handleDrop = (event: DragEvent) => {
            event.preventDefault();
            textarea.style.border = "0";
            textarea.style.setProperty("opacity", "1");
            setIsDrop(false);
        };

        textarea.addEventListener("dragover", handleDragOver);
        textarea.addEventListener("dragleave", handleDragLeave);
        textarea.addEventListener("drop", handleDrop);

        return () => {
            textarea.removeEventListener("dragover", handleDragOver);
            textarea.removeEventListener("dragleave", handleDragLeave);
            textarea.removeEventListener("drop", handleDrop);
        };
    }, []);
    
    const handlePaste = (e: any) => {
        if (e.clipboardData.files && e.clipboardData.files.length > 0) {
            Array.from(e.clipboardData.files).forEach(file => handleFile(file));
        }
    };

    const handleFile = async(file: any) => {
        file = await convertHeic(file);
        file = await compressImage(file);
        const type = file.type;
    
        if ((type.startsWith("image/") || type.startsWith("video/"))  && cameraInputRef.current?.files) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            cameraInputRef.current.files = dataTransfer.files;
        
            const reader = new FileReader();
            reader.onload = (e) => {
                const src = e.target?.result;
                if (typeof src === "string") {
                    const newFiles = [...selectedFiles, { file, src }];
                    setSelectedFiles(newFiles);
                    setImagePreviewCaption("");
                    setShowImagePreview(true);
                }
            };
            reader.readAsDataURL(file);
        } else if (fileInputRef.current) {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(file);
            fileInputRef.current.files = dataTransfer.files;
        
            const reader = new FileReader();
            reader.onload = (e) => {
                const src = e.target?.result;
                if (typeof src === "string") {
                    const newFiles = [...selectedFiles, { file, src }];
                    setSelectedFiles(newFiles);
                }
            };
            reader.readAsDataURL(file);
            // const dataTransfer = new DataTransfer();
            // dataTransfer.items.add(file);
            // fileInputRef.current.files = dataTransfer.files;
            // const url = URL.createObjectURL(file);
            // setSelectedFiles(url);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        const screenWidth = window.innerWidth;

        if (e.key === "Enter") {
            if (e.shiftKey || screenWidth <= 850) {
                e.preventDefault();

                const textarea = e.currentTarget;
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;

                setText((prev) => {
                    const newText =
                        prev.substring(0, start) +
                        "\n" +
                        prev.substring(end);

                    // reposiciona o cursor após o React atualizar o estado
                    setTimeout(() => {
                        textarea.selectionStart = textarea.selectionEnd = start + 1;
                    }, 0);

                    return newText;
                });
            } else if (screenWidth > 850 && text.trim().length > 0) {
                e.preventDefault();
                handleSubmitMessage();
            }
        }
    };

    const deleteMessages = async (forAll: boolean) => {
        setShowConfirmationDeleteMessage(false);
        setShowConfirmationDeleteMessageForAll(false);
        setSelectedMessages([])
        const oldMessages = messages;
        const updatedMessages = messages.filter(msg => !selectedMessages.includes(msg.id));
        setMessages(updatedMessages);

        if (chatSelected) {
            const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
            const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
            messagesByChat[chatSelected.chat_id] = updatedMessages;
            localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));
        }

        try {
            await axios.post(`${PACOCA_API_URL}/chats/messages/delete`, {
                ids: selectedMessages, for_all: forAll // "me" ou "all"
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
        } catch (err: any) {
            setMessages(oldMessages);// Restaura mensagens removidas
            setShowConfirmationDeleteMessage(false)
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
            console.error('Erro:', messageError);

            // Restaura no localStorage
            if(chatSelected){
                const storedAgain = localStorage.getItem(`messagesByChat-${user?.id}`);
                const messagesByChatAgain: { [key: number]: MessageChat[] } = storedAgain ? JSON.parse(storedAgain) : {};

                messagesByChatAgain[chatSelected.chat_id] = oldMessages;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChatAgain));
            }
        } 
    };

    const handleClickEmoji = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        setText((prev) => {
            if (prev[start - 1] === ":") return prev;

            const needsSpaceBefore =
                start > 0 && prev[start - 1] !== " " && prev[start - 1] !== "\n";

            const insertText = needsSpaceBefore ? " :" : ":";

            const newText =
                prev.substring(0, start) +
                insertText +
                prev.substring(end);

            setTimeout(() => {
                const pos = start + insertText.length;

                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = pos;

                // 🔥 SIMULA DIGITAÇÃO REAL
                textarea.dispatchEvent(new Event("input", { bubbles: true }));
            }, 0);

            return newText;
        });
    };

    const loadMessages = async (page: number, requestedChatId?: number) => {
        const targetChatId = requestedChatId ?? chatSelectedRef.current?.chat_id ?? chatSelected?.chat_id;
        const requestVersion = chatLoadVersionRef.current;
        const controller = new AbortController();
        const isCurrentRequest = () =>
            chatLoadVersionRef.current === requestVersion &&
            chatIdRef.current === chatId &&
            Number(chatSelectedRef.current?.chat_id) === Number(targetChatId);
        const isCanceled = (err: unknown) =>
            controller.signal.aborted || axios.isCancel(err) || (err as any)?.code === "ERR_CANCELED";

        messagesAbortControllerRef.current?.abort();
        messagesAbortControllerRef.current = controller;
        setLoadingMessages(true);

        if (!targetChatId || !location.pathname.includes("/chat/")) {
            if (messagesAbortControllerRef.current === controller) {
                messagesAbortControllerRef.current = null;
                setLoadingMessages(false);
            }
            return;
        }

        // Carrega mensagens locais ANTES de buscar na API, mas só se esta ainda
        // for a conversa ativa. Isso evita exibir o cache do chat anterior.
        try {
            const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
            if (stored && isCurrentRequest()) {
                const messagesByChat = JSON.parse(stored);
                const localMessages = messagesByChat[targetChatId];
                if (Array.isArray(localMessages)) setMessages(localMessages);
            }
        } catch (err) {
            console.warn("Erro ao ler mensagens locais:", err);
        }

        const url = `${PACOCA_API_URL}/chats/messages/${targetChatId}/?page=${page}`;

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                signal: controller.signal,
            });

            if (!isCurrentRequest()) return;

            const data: MessageChat[] = Array.isArray(response.data.messages)
                ? response.data.messages
                : [];

            // A response for an old chat is ignored above. Always replace the
            // active chat with the API result, including an empty result, so a
            // previous chat's cached messages cannot remain on screen.
            setMessages(data);

            try {
                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                messagesByChat[targetChatId] = data;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));
            } catch (err) {
                console.warn("Erro ao salvar mensagens locais:", err);
            }

            if (data.length > 0) {
                const latestIncomingId = data.reduce((latest: number, message: MessageChat) =>
                    message.user_id !== user?.id ? Math.max(latest, Number(message.id)) : latest, 0);
                if (latestIncomingId) scheduleMarkMessagesAsRead(targetChatId, latestIncomingId);

                // Atualiza a prévia do chat no cache local.
                try {
                    const chatsStored = localStorage.getItem(getChatListCacheKey(user?.id));
                    if (chatsStored) {
                        const chats = JSON.parse(chatsStored);
                        const indexChat = chats.findIndex((item: any) => item.chat_id == targetChatId);
                        if (indexChat !== -1) {
                            const lastMsg = data[data.length - 1];
                            chats[indexChat].last_message = JSON.stringify(lastMsg);
                            chats[indexChat].last_message_read = lastMsg.id;
                            localStorage.setItem(getChatListCacheKey(user?.id), JSON.stringify(chats));
                        }
                    }
                } catch (err) {
                    console.warn("Erro ao atualizar prévia local do chat:", err);
                }
            } else {
                setEnd(true);
            }
        } catch (err: any) {
            if (!isCurrentRequest() || isCanceled(err)) return;
            const messageError = errorMessage(err);
            console.error("Erro:", err);
            console.error("Erro:", messageError);
        } finally {
            if (messagesAbortControllerRef.current === controller) {
                messagesAbortControllerRef.current = null;
                if (isCurrentRequest()) setLoadingMessages(false);
            }
        }
    };

    // ── Fallback: reload messages when the tab becomes visible again ──────────
    // Covers WS events missed while the tab was hidden (e.g. screen locked,
    // another app in focus, or a transient connection drop).
    const loadMessagesRef = useRef(loadMessages);
    loadMessagesRef.current = loadMessages;

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && chatSelectedRef.current?.chat_id) {
                loadMessagesRef.current(1);
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    const markChatAsRead = (chatId: number) => {
        const chatsStored = localStorage.getItem(getChatListCacheKey(user?.id));
        if (chatsStored) {
            const chats = JSON.parse(chatsStored);
            const index = chats.findIndex((c: any) => c.chat_id == chatId);
            if (index !== -1) {
                chats[index].has_new_message = false;
                localStorage.setItem(getChatListCacheKey(user?.id), JSON.stringify(chats));

                if(!chatSelected) return;
                // atualiza members
                const mergedChats = members?.map((chatFromApi) => {
                    if (chatFromApi.chat_id == chatSelected.chat_id) {
                        return {
                            ...chatFromApi,
                            last_message_read: null,
                        };
                    }
                    return chatFromApi;
                });

                if(mergedChats) setMembers(mergedChats);
            }
        }
    };

    useEffect(() => {
        if (chatSelected?.chat_id) {
            markChatAsRead(chatSelected.chat_id);
        }
    }, [chatSelected]);

    const changeChat = (newMember: ChatType | null) => {
        cancelReply();
        cancelEdit();
        setSelectedFiles([]);
        setShowImagePreview(false);
        setIsViewOnce(false);
        if (!newMember || (newMember && newMember != chatSelected)) {
            setPage(1)
            setMessages([]);
            setChatSelected(newMember);
            setShowGroupInfo(false);
        }
        if (newMember) {
            if (newMember.is_group) {
                navigate(`/chat/${newMember.chat_id}`);
            } else {
                navigate(`/chat/@${newMember.user_name}`); // Atualiza a URL
            }
        } else {
            navigate(`/chat`); // Atualiza a URL
        }
    }

    useEffect(() => {
        cancelReply();
        cancelEdit();
        setSelectedFiles([]);
        setShowImagePreview(false);
        setIsViewOnce(false);
    }, [chatSelected])

    const handleInputTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        scheduleTypingIndicator(newText);
    }

    const cancelEdit = () => {
        setIsEdditing(false)
        setText("")
        setIdCommentEdit(null)
    }

    const cancelReply = () => {
        setReplyingTo(null);
    }

    const handleReactMessage = async (messageId: number, emoji: string) => {
        if (!user) return;

        // Optimistic update
        setMessages((prevMessages) => {
            const updated = prevMessages.map((msg) => {
                if (msg.id !== messageId) return msg;

                const currentReactions = msg.reactions || [];
                const existingIndex = currentReactions.findIndex((r) => r.user_id === user.id);

                let nextReactions = [...currentReactions];
                if (existingIndex !== -1) {
                    if (nextReactions[existingIndex].emoji === emoji) {
                        // Toggle off
                        nextReactions.splice(existingIndex, 1);
                    } else {
                        // Update
                        nextReactions[existingIndex] = {
                            ...nextReactions[existingIndex],
                            emoji,
                        };
                    }
                } else {
                    // Add
                    nextReactions.push({
                        chat_message_id: messageId,
                        user_id: user.id,
                        emoji,
                        user,
                    });
                }

                return {
                    ...msg,
                    reactions: nextReactions,
                };
            });

            const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
            const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
            if (chatSelected?.chat_id) {
                messagesByChat[chatSelected.chat_id] = updated;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));
            }

            return updated;
        });

        try {
            const response = await api(token).post(`/chats/messages/${messageId}/react`, { emoji });
            if (response.data?.reactions) {
                setMessages((prevMessages) => {
                    const updated = prevMessages.map((msg) => {
                        if (msg.id !== messageId) return msg;
                        return {
                            ...msg,
                            reactions: response.data.reactions,
                        };
                    });

                    const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                    const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                    if (chatSelected?.chat_id) {
                        messagesByChat[chatSelected.chat_id] = updated;
                        localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));
                    }

                    return updated;
                });
            }
        } catch (err) {
            console.error("Failed to react to message:", err);
            // Reload messages if failed
            if (chatSelected?.chat_id) {
                loadMessages(1);
            }
        }
    };

    // ── Pinned messages ───────────────────────────────────────────────────────
    const [pinnedMessages, setPinnedMessages] = useState<PinnedMessage[]>([]);
    const [showPinnedBanner, setShowPinnedBanner] = useState(false);

    const loadPinnedMessages = async (chatId: number) => {
        try {
            const res = await api(token).get(`${PACOCA_API_URL}/chats/${chatId}/pinned`);
            const pins: PinnedMessage[] = res.data.pinned ?? [];
            setPinnedMessages(pins);
            // Mark messages that are pinned
            setMessages(prev => prev.map(m => ({
                ...m,
                is_pinned: pins.some(p => p.chat_message_id === m.id),
            })));
        } catch {}
    };

    useEffect(() => {
        if (chatSelected?.chat_id && !isAiConvId(String(chatSelected.chat_id))) {
            loadPinnedMessages(chatSelected.chat_id);
        } else {
            setPinnedMessages([]);
        }
    }, [chatSelected?.chat_id]);

    const handlePinMessage = async (m: MessageChat) => {
        if (!chatSelected?.chat_id) return;
        const chatId = chatSelected.chat_id;
        const isPinned = m.is_pinned;
        try {
            if (isPinned) {
                await api(token).delete(`${PACOCA_API_URL}/chats/${chatId}/pinned/${m.id}`);
                setPinnedMessages(prev => prev.filter(p => p.chat_message_id !== m.id));
                setMessages(prev => prev.map(msg => msg.id === m.id ? { ...msg, is_pinned: false } : msg));
            } else {
                const res = await api(token).post(`${PACOCA_API_URL}/chats/${chatId}/pinned/${m.id}`);
                const newPin: PinnedMessage = res.data.pin;
                setPinnedMessages(prev => {
                    const updated = [newPin, ...prev].slice(0, 3);
                    return updated;
                });
                setMessages(prev => prev.map(msg => msg.id === m.id ? { ...msg, is_pinned: true } : msg));
            }
        } catch (err: any) {
            const msg = err?.response?.data?.message || t("generics.error");
            setMessage(msg, "error");
        }
    };

    // ── Favorite messages ─────────────────────────────────────────────────────
    const handleFavoriteMessage = async (m: MessageChat) => {
        const isFav = m.is_favorited;
        // Optimistic update
        setMessages(prev => prev.map(msg => msg.id === m.id ? { ...msg, is_favorited: !isFav } : msg));
        try {
            await api(token).post(`${PACOCA_API_URL}/chats/messages/${m.id}/favorite`);
        } catch (err: any) {
            // Rollback
            setMessages(prev => prev.map(msg => msg.id === m.id ? { ...msg, is_favorited: isFav } : msg));
            const msg = err?.response?.data?.message || t("generics.error");
            setMessage(msg, "error");
        }
    };
    // ── Forward messages ───────────────────────────────────────────────────────
    const handleForwardMessages = async (targetChatId: number) => {
        const msgsToForward = messages.filter(m => selectedMessages.includes(m.id));
        for (const m of msgsToForward) {
            try {
                const formData = new FormData();
                formData.append("chat_id", String(targetChatId));
                if (m.text?.trim()) formData.append("text", m.text);
                if (m.gif_url) {
                    formData.append("text", m.gif_url);
                    formData.append("is_gif", "1");
                }
                await api(token).post(`${PACOCA_API_URL}/chats/messages`, formData);
            } catch (err) {
                console.error("Erro ao encaminhar mensagem", err);
            }
        }
        setSelectedMessages([]);
    };
    // ─────────────────────────────────────────────────────────────────────────

    const edit = (message: MessageChat) => {
        setIsEdditing(true);
        setSelectedMessages([]);
        setText(message.text);
        setIdCommentEdit(message);
    }

    // const handleSubmitAudioMessage = async (blob: Blob) => {
    //     if (!blob || !chatSelected) return;

    //     const audioURL = URL.createObjectURL(blob); // pega aqui direto do blob
    //     var tempId = Date.now(); // ID temporário
    //     const newMessageData = {
    //         id: Number(tempId), // ID temporário
    //         idNotSend: true,
    //         user_id: Number(user?.id),
    //         user: user as User,
    //         created_at: new Date().toISOString(),
    //         chat_id: Number(chatSelected?.chat_id),
    //         text: "",
    //         file_path: JSON.stringify([audioURL]),        
    //         file_type: JSON.stringify(["video/webm"])
    //     };

    //     setMessages((prevData) => {
    //         const updatedMessages = [...prevData, newMessageData];

    //         const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
    //         const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
    //         messagesByChat[chatSelected.chat_id] = updatedMessages;
    //         localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));

    //         return updatedMessages;
    //     });

    //     const formData = new FormData();
    //     formData.append("chat_id", String(chatSelected.chat_id));
    //     formData.append("file[]", blob, "audio.webm");

    //     try {
    //         const response = await axios.post(`${PACOCA_API_URL}/chats/messages`, formData, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //                 Accept: "application/json"
    //             }
    //         });

    //         setMessages((prevData) => {
    //             const filteredMessages = prevData.map((message) =>
    //                 message.id === tempId ? { ...message, id: response?.data?.message?.id, idNotSend: false } : message
    //             );

    //             const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
    //             const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
    //             messagesByChat[chatSelected.chat_id] = filteredMessages;
    //             localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));

    //             return filteredMessages;
    //         });
    //         // setTimeout(() => {
    //             scrollToBottom(false);
    //         // }, 100);
    //         setAudioURL(""); // limpa após envio
    //     } catch (err) {
    //         console.error("Erro ao enviar áudio:", err);
    //     }
    // };

    const [isViewOnce, setIsViewOnce] = useState(false);

    const handleSubmitMessage = async (textParam?: string, isGif = false, filesParam?: FilePreview[], viewOnceParam = false) => {
        stopTypingIndicator();
        if(!chatSelected){
            handleSubmitMessagePacocaAI(textParam);
            return;
        }
        if (chatSelected.can_manage_request) {
            setMessage(t('chat.messageRequests.mustAccept'), 'error');
            return;
        }

        setLoadingSendMessage(true);

        const filesToSend = filesParam ?? selectedFiles;
        const oldText = text;
        const oldIsEdditing = isEdditing;
        var tempId = Date.now(); // ID temporário
        const currentReplyingTo = replyingTo;
        const newMessageData: MessageChat = {
            id: Number(tempId), // ID temporário
            idNotSend: true,
            user_id: Number(user?.id),
            user: user as User,
            created_at: new Date().toISOString(),
            chat_id: Number(chatSelected?.chat_id),
            text: textParam ?? text,
            file_path: JSON.stringify(filesToSend.map(file => URL.createObjectURL(file.file))),
            file_type: JSON.stringify(filesToSend.map(file => file.file.type)),
            file_name: JSON.stringify(filesToSend.map(file => file.file.name)),
            gif_url: isGif ? textParam : undefined,
            reply_to_id: currentReplyingTo?.id ?? null,
            reply_to: currentReplyingTo ?? null,
            is_view_once: viewOnceParam,
            view_once_opened_at: null,
        };

        // Adiciona o comentário na lista antes de enviar a requisição
        if (!isEdditing)
            setMessages((prevData) => {
                const updatedMessages = [...prevData, newMessageData];

                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                messagesByChat[chatSelected.chat_id] = updatedMessages;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));

                return updatedMessages;
            });
        else {
            var oldTextEdditing = "";
            setMessages((prevData) => {
                const updatedMessages = prevData.map((msg) =>
                msg.id === idCommentEdit?.id
                    ? { ...msg, text: newMessageData.text } // atualiza o texto
                    : msg
                );

                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                messagesByChat[chatSelected.chat_id] = updatedMessages;
                localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(messagesByChat));

                return updatedMessages;
            });
            oldTextEdditing = idCommentEdit?.text ?? "";
            tempId = idCommentEdit?.id ?? 0
        }
        cancelEdit();
        cancelReply();

        scrollToBottom(true);
        try {
            const formData = new FormData();
            formData.append("text", textParam ?? text);
            formData.append("id_comment", String(tempId)); //para edição
            formData.append("chat_id", String(chatSelected?.chat_id));
            if(viewOnceParam) {
                formData.append("is_view_once", "1");
            }
            if(currentReplyingTo?.id)
                formData.append("reply_to_id", String(currentReplyingTo.id));
            filesToSend.forEach(f => {
                formData.append("file[]", f.file);
            });
            
            if(isGif && textParam)
                formData.append("gif_url", textParam);

            setSelectedFiles([]);
            setIsViewOnce(false);
            const url = !isEdditing ? (`${PACOCA_API_URL}/chats/messages/`) : (`${PACOCA_API_URL}/chats/messages/${tempId}`);
            var response: any;
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            if (!isEdditing) {
                response = await axios.post(url, formData, config);
            } else {
                response = await axios.post(url, formData, config);
            }

            if(textParam ?? text)
                checkAndTrigger(textParam ?? text, "post")
            
            const realId: number = response?.data?.message?.id;
            // Register BEFORE setMessages — blocks any late WS event with this id
            confirmedIdsRef.current.add(realId);

            // If the message mentions the AI, poll for the reply as a WS fallback
            const sentText = (textParam ?? text).toLowerCase();
            if (sentText.includes("@pacoca_ai") || sentText.includes("@bochechaai")) {
                scheduleAiReplyPoll(realId);
            }

            setMessages((prevData) => {
                // Replace tempId with realId; also remove any stray duplicate with realId
                const withoutDuplicate = prevData.filter(m => m.id !== realId);
                const filteredMessages = withoutDuplicate.map((m) =>
                    m.id === tempId ? { ...m, id: realId, idNotSend: false } : m
                );

                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                const messagesByChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                messagesByChat[chatSelected.chat_id] = filteredMessages;

                return filteredMessages;
            });
            // setTimeout(() => {
                scrollToBottom(false);
            // }, 100);
        } catch (err: any) {
            // Se houver erro, remove o comentário temporário
            if(!oldIsEdditing) setMessages((prevData) => prevData.filter((comment) => comment.id !== tempId));
            if(!oldIsEdditing) setText(oldText);

            if(oldIsEdditing){
                setMessages((prevData) =>
                    prevData.map((comment) =>
                        comment.id === tempId ? { ...comment, text: oldTextEdditing } : comment
                    )
                );
            }

            setSelectedFiles(filesToSend);
            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err)
            setMessage(messageError, type)
            console.error('Erro:', err);
            console.error('Erro:', messageError);
        }
    };

    /** Polls for new messages after mentioning the AI, as a fallback in case
     *  the WebSocket event is missed (connection drop, late delivery, etc.).
     *  Schedules 3 fetches: at 4 s, 10 s, and 20 s after sending. */
    const scheduleAiReplyPoll = (afterMessageId: number) => {
        // Clear any outstanding timers from a previous mention
        aiPollTimersRef.current.forEach(clearTimeout);
        aiPollTimersRef.current = [];

        const poll = async () => {
            const currentChat = chatSelectedRef.current;
            if (!currentChat?.chat_id || !token) return;

            try {
                const response = await axios.get(
                    `${PACOCA_API_URL}/chats/messages/${currentChat.chat_id}/?page=1`,
                    { headers: { Accept: "application/json", Authorization: `Bearer ${token}` } }
                );
                const data: MessageChat[] = response.data.messages ?? [];
                if (!data.length) return;

                setMessages(prev => {
                    // Only add truly new messages (id > afterMessageId) that aren't already present
                    const existingIds = new Set(prev.map(m => m.id));
                    const newMsgs = data.filter(
                        m => m.id > afterMessageId && !existingIds.has(m.id)
                    );
                    if (!newMsgs.length) return prev;

                    const updated = [...prev, ...newMsgs];

                    // Persist to localStorage
                    const stored = localStorage.getItem(`messagesByChat-${userIdRef.current}`);
                    const byChat: { [key: number]: MessageChat[] } = stored ? JSON.parse(stored) : {};
                    byChat[currentChat.chat_id] = updated;
                    localStorage.setItem(`messagesByChat-${userIdRef.current}`, JSON.stringify(byChat));

                    return updated;
                });
            } catch { /* silently ignore poll errors */ }
        };

        [4000, 10000, 20000].forEach(delay => {
            aiPollTimersRef.current.push(setTimeout(poll, delay));
        });
    };

    const handleSubmitMessagePacocaAI = async (textParam?: string) => {
        if (loadingIAResponse) {
            handleStopResponse(); // Para antes de continuar
            return;
        }

        const messageText = textParam ?? text;

        // Ensure a conversation exists before sending
        const convId = ensureActiveConversation();

        const controller = new AbortController();
        controllerRef.current = controller;

        setLoadingIAResponse(true);
        textareaRef.current?.blur();

        const oldText = text;
        const tempId = Date.now(); // ID temporário da mensagem do usuário
        const newMessageData = {
            id: tempId,
            idNotSend: false,   // AI-mode user messages need no server confirmation
            user_id: Number(user?.id),
            created_at: new Date().toISOString(),
            chat_id: Number(chatSelected?.chat_id),
            text: messageText,
        };

        setText("");
        // Adiciona a mensagem do usuário
        setMessages((prevData) => [...prevData, newMessageData]);
        cancelEdit();

        // Set title immediately from the first user message
        {
            const conv = getConversation(user?.id, convId);
            if (conv?.title === "Nova conversa") {
                const titleFromInput = deriveTitleFromMessage(messageText);
                updateConversation(user?.id, convId, { title: titleFromInput });
                setAiConversations(loadConversations(user?.id));
            }
        }

        // Adiciona a mensagem "digitando..." da IA
        const tempIdIa = Date.now() + 2; // ID temporário da mensagem do usuário
        setIdCurrentIAResponse(tempIdIa);
        const typingMessage = {
            id: tempIdIa,
            idNotSend: true,
            user_id: 0,
            created_at: new Date().toISOString(),
            chat_id: Number(chatSelected?.chat_id),
            text: "Pensando...",
            isTyping: true, // você pode usar isso pra mostrar um ícone de loading
        };
        setMessages(prev => [...prev, typingMessage]);

        try {
            const MAX_HISTORY = 10;

            const recentMessages = messages
                .slice(-MAX_HISTORY)
                .map(m => ({
                    role: m.user_id === 0 ? "assistant" : "user",
                    content: m.text
                }));

            const updatedMessages = [
                ...recentMessages,
                { role: "user", content: messageText }
            ];
            
            scrollToBottom(true);
            const response = await fetch(`${PACOCA_API_URL}/ai/chat`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "Accept": "text/event-stream",
                    "Cache-Control": "no-cache",
                    "Connection": "keep-alive"
                },
                body: JSON.stringify({
                    messages: updatedMessages,
                    ia: selectedIa.id == 2 ? "bochecha" : "pacoca"
                })
            });

            if (!response.ok || !response.body) {
                const errorJson = await response.json();
                console.error(response);
                console.error("Erro detalhado:", errorJson);
                throw new Error(`Erro ${response.status}: ${errorJson.detail || "Erro desconhecido."}`);
            }



            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let finalText = "";
            let buffer = "";

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });

                const lines = buffer.split("\n");
                buffer = lines.pop() || "";

                for (const lineRaw of lines) {
                    const line = lineRaw.trim();

                    if (!line.startsWith("data:")) continue;

                    const data = line.replace("data:", "").trim();

                    if (data === "[DONE]") {
                        break;
                    }

                    try {
                        const json = JSON.parse(data);

                        const content = json.choices?.[0]?.delta?.content;

                        if (!content) continue;

                        setLoadingIAResponse(false);
                        scrollToBottom(true);
                        finalText += content;

                        setMessages(prev => {
                            const updated = [...prev];
                            const index = updated.findIndex(m => m.id === tempIdIa);

                            if (index !== -1) {
                                updated[index] = {
                                    ...updated[index],
                                    text: finalText,
                                    isTyping: false
                                };
                            }

                            return updated;
                        });

                    } catch (err) {
                        console.warn("Erro parse:", data);
                    }
                }
            }

            if (detectAiLimitMessage(finalText)) {
                setAiLimitReached(selectedIa.id == 2 ? "bochecha" : "pacoca", user?.id);
                setShowAiLimitBanner(true);
            }

            // Persist conversation
            setMessages(prev => {
                // Build a clean snapshot: replace the AI typing placeholder with final text
                const updated = prev.map(m =>
                    m.id === tempIdIa ? { ...m, text: finalText, isTyping: false, idNotSend: false } : m
                );
                const clean = updated.filter(m => !m.idNotSend && m.text.trim().length > 0);
                // Set title from first user message if still "Nova conversa"
                const conv = getConversation(user?.id, convId);
                const firstUserMsg = clean.find(m => m.user_id !== 0);
                const title = (conv?.title === "Nova conversa" && firstUserMsg)
                    ? deriveTitleFromMessage(firstUserMsg.text)
                    : (conv?.title ?? "Nova conversa");
                updateConversation(user?.id, convId, { messages: clean as any, title });
                setAiConversations(loadConversations(user?.id));
                return prev; // state was already updated by streaming
            });
        } catch (err: any) {
            if (err.name === 'AbortError') {
                console.warn("Requisição cancelada");
                return;
            }

            const type = err?.response?.data?.type_message || "error";
            const messageError = errorMessage(err);

            setLoadingIAResponse(false);
            scrollToBottom(true);

            setMessages(prev =>
                prev.map(msg =>
                    msg.id == tempIdIa ? { ...msg, text: messageError} : msg
                )
            );

            setText(oldText);
            console.error(PACOCA_AI_URL);
            console.error('Erro:', err);
        } finally {
            setSelectedMessages([])
        }
    };

    const handleStopResponse = () => {
        if (controllerRef.current) {
            controllerRef.current.abort();
            controllerRef.current = null;
        }

        setIdCurrentIAResponse(null);
        setLoadingIAResponse(false);
    };


    const formatarData = (isoDate: string) => {
        const date = new Date(isoDate);
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const getDateLabel = (isoDate: string) => {
        const date = new Date(isoDate);
        const now = new Date();
        const toDay = (d: Date) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
        if (toDay(date) === toDay(now)) return t("chat.dateLabel.today");
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        if (toDay(date) === toDay(yesterday)) return t("chat.dateLabel.yesterday");
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const thisYear = now.getFullYear();
        const dateStr = year === thisYear ? `${day}/${month}` : `${day}/${month}/${year}`;
        const langMap: Record<string, string> = { pt: "pt-BR", pt_BR: "pt-BR", pt_PT: "pt-PT", es: "es", es_ES: "es", us: "en", en: "en" };
        const lang = localStorage.getItem("language") ?? "pt";
        const locale = langMap[lang] ?? "pt-BR";
        const weekday = date.toLocaleDateString(locale, { weekday: "long" });
        return `${dateStr} - ${weekday}`;
    };

    useEffect(() => {
        const elements = [
            document.body,
            document.querySelector("html"),
            // document.documentElement,
            // document.querySelector("main"),
            // document.querySelector(".col-conversa") as HTMLElement,
            // document.querySelector("#root") as HTMLElement,
        ];

        if (location.pathname.includes("/chat")) {
            elements.forEach((el) => el && (el.style.overflow = "hidden"));
        } else {
            elements.forEach((el) => el && (el.style.overflow = ""));
        }

        // Limpa ao desmontar
        return () => {
            elements.forEach((el) => el && (el.style.overflow = ""));
        };
    }, [location.pathname]);


    const resizeTextarea = () => {
        const textarea = textareaRef.current;
        if (!textarea) return;

        const minHeight = 30; // mesma altura do rows={1}
        setTextareaHeight(minHeight);

        textarea.style.height = "auto";
        textarea.scrollTop = 0; // 🔑 limpa scroll antigo

        const scrollHeight = textarea.scrollHeight;

        const maxHeight = parseFloat(
            getComputedStyle(textarea).maxHeight || "0"
        );

        if (scrollHeight <= minHeight) {
            setTextareaHeight(minHeight);
            textarea.style.height = `${minHeight}px`;
            textarea.style.overflowY = "hidden";
            return;
        }

        if (maxHeight && scrollHeight > maxHeight) {
            setTextareaHeight(maxHeight);
            textarea.style.height = `${maxHeight}px`;
            textarea.style.overflowY = "auto";
        } else {
            setTextareaHeight(scrollHeight);
            textarea.style.height = `${scrollHeight}px`;
            textarea.style.overflowY = "hidden";
        }
    };

    useEffect(() => {
        resizeTextarea();
    }, [text]);

    const handleClickGif = (sticky: string) => {
        handleSubmitMessage(sticky, true);
    }

    const cleanOpenChat = () => {
        setChatSelected(null);
        changeChat(null);
        setLoadingMessages(false);
    }

    const handleClickSticky = (sticky: string) => {
        handleSubmitMessage(sticky);
    }

    const handleClearConversation = async () => {
        if (!chatSelected?.chat_id || isClearingConversation) return;
        setIsClearingConversation(true);
        try {
            await api(token).delete(`${PACOCA_API_URL}/chats/${chatSelected.chat_id}`);
            setMessages([]);
            // Remove from local cache so the list updates
            try {
                const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                if (stored) {
                    const map = JSON.parse(stored);
                    delete map[chatSelected.chat_id];
                    localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(map));
                }
            } catch { /* ignore */ }
            setMembers(prev => prev ? prev.filter(m => m.chat_id !== chatSelected.chat_id) : prev);
        } catch {
            // silent
        } finally {
            setIsClearingConversation(false);
            setShowConfirmClearConversation(false);
        }
    };

    // ── AI conversation helpers ───────────────────────────────────────────────

    /** Ensure an active AI conversation exists; if not, create one. */
    const ensureActiveConversation = (): string => {
        const aiKey = selectedIa.id == 2 ? "bochecha" : "pacoca";
        // The URL is the source of truth: chatId starting with "ia-" IS the conv id
        const id = (chatId && isAiConvId(chatId)) ? chatId : activeConvId;
        if (id) {
            const existing = getConversation(user?.id, id);
            if (existing) return id;
        }
        // Fallback: create a new conversation (should rarely happen)
        const conv = createConversation(user?.id, aiKey);
        setActiveConvId(conv.id);
        setActiveConversationId(user?.id, conv.id);
        setAiConversations(loadConversations(user?.id));
        navigate(`/chat/${conv.id}`, { replace: true });
        return conv.id;
    };

    /** Save current messages snapshot to the active conversation */
    const saveMessagesToConversation = (convId: string, msgs: MessageChat[]) => {
        const clean = msgs.filter(m => !m.idNotSend && m.text.trim().length > 0);
        if (clean.length === 0) return;
        updateConversation(user?.id, convId, { messages: clean as any });
        setAiConversations(loadConversations(user?.id));
    };

    /** Switch to a saved AI conversation — updates URL so reload restores it */
    const switchAiConversation = (conv: AiConversation) => {
        setMessages(conv.messages as any);
        setSelectedIa(conv.ai === "bochecha" ? ias[1] : ias[0]);
        setActiveConvId(conv.id);
        setActiveConversationId(user?.id, conv.id);
        setShowAiConvList(false);
        navigate(`/chat/${conv.id}`, { replace: true });
    };

    /** Start a brand-new AI conversation — updates URL so reload restores it */
    const startNewAiConversation = () => {
        if (!canStartNewAiConversation(messages)) {
            setShowAiConvList(false);
            return;
        }

        const aiKey = selectedIa.id == 2 ? "bochecha" : "pacoca";
        const conv = createConversation(user?.id, aiKey);
        setMessages([]);
        setActiveConvId(conv.id);
        setActiveConversationId(user?.id, conv.id);
        setAiConversations(loadConversations(user?.id));
        setShowAiConvList(false);
        navigate(`/chat/${conv.id}`, { replace: true });
    };

    // ── AI URL routing: resolve which conversation to show ────────────────────
    // Runs once on mount and whenever chatId changes (e.g. back-navigation).
    useEffect(() => {
        // Check the URL before chatSelected. On a normal → AI navigation the
        // previous chat is still in state during this render; route changes
        // must still restore the requested AI conversation.
        if (chatId && isAiConvId(chatId)) {
            // Page reload or direct link: restore the specific conversation.
            // Try both new format (ia-...) and old format (timestamp-rand) as stored id.
            const conv = getConversation(user?.id, chatId);
            if (conv) {
                setSelectedIa(conv.ai === "bochecha" ? ias[1] : ias[0]);
                setActiveConvId(chatId);
                setActiveConversationId(user?.id, chatId);
                setMessages(conv.messages as any);
            } else {
                // Conversation not found (cleared localStorage?) — start fresh
                navigate("/chat", { replace: true });
            }
            return;
        }

        if (chatSelected) return; // normal chat — AI logic doesn't apply

        if (!chatId) {
            // If there's already an active conversation open, just navigate back to it
            if (activeConvId) {
                const existing = getConversation(user?.id, activeConvId);
                if (existing) {
                    navigate(`/chat/${activeConvId}`, { replace: true });
                    return;
                }
            }
            // No active conversation — start a fresh one
            const aiKey = selectedIa.id == 2 ? "bochecha" : "pacoca";
            const conv = createConversation(user?.id, aiKey);
            setMessages([]);
            setActiveConvId(conv.id);
            setActiveConversationId(user?.id, conv.id);
            setAiConversations(loadConversations(user?.id));
            navigate(`/chat/${conv.id}`, { replace: true });
        }
    }, [chatId]);

    // On unmount: delete the active AI conversation if it has no messages
    useEffect(() => {
        return () => {
            const convId = activeConvIdRef.current;
            if (!convId) return;
            const conv = getConversation(userIdRef.current, convId);
            if (conv && conv.messages.length === 0) {
                deleteConversation(userIdRef.current, convId);
            }
        };
    }, []);

    // ─────────────────────────────────────────────────────────────────────────

    
    // useEffect(() => {
    //     let interval: NodeJS.Timeout | null = null;

    //     const checkOnline = async () => {
    //         try {
    //             const res = await api(token).get(`/users/online/${chatSelected?.user_id}`);
    //             setChatSelected(prev => {
    //                 if (!prev) return prev;

    //                 return {
    //                     ...prev,
    //                     is_online: res.data.online
    //                 };
    //             });
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     };

    //     const start = () => {
    //         checkOnline();
    //         interval = setInterval(checkOnline, 30000);
    //     };

    //     const stop = () => {
    //         if (interval) clearInterval(interval);
    //         interval = null;
    //     };

    //     const handleVisibility = () => {
    //         if (document.visibilityState === "visible") {
    //             start();
    //         } else {
    //             stop();
    //         }
    //     };

    //     handleVisibility(); // roda na primeira vez
    //     document.addEventListener("visibilitychange", handleVisibility);

    //     return () => {
    //         stop();
    //         document.removeEventListener("visibilitychange", handleVisibility);
    //     };

    // }, [chatSelected?.user_id]);

    const handleRequestAction = async (action: 'accept' | 'general' | 'delete') => {
        if (!chatSelected) return;
        try {
            if (action === 'delete') {
                await api(token).delete(`/chats/${chatSelected.chat_id}/request`);
                invalidateChatListCache(user?.id);
                setMembers(prev => prev ? prev.filter(chat => chat.chat_id !== chatSelected.chat_id) : prev);
                cleanOpenChat();
                navigate('/chat', { replace: true });
                setMessage(t('chat.messageRequests.deleted'), 'success');
                return;
            }

            const inbox = action === 'general' ? 'general' : 'principal';
            await api(token).post(`/chats/${chatSelected.chat_id}/request/accept`, { inbox });
            invalidateChatListCache(user?.id);
            // The active list can still be the Solicitações tab. Remove the
            // accepted request immediately; its destination inbox is loaded
            // from the server when that category is shown.
            setMembers(prev => prev ? prev.filter(chat => chat.chat_id !== chatSelected.chat_id) : prev);
            setChatSelected(current => current ? {
                ...current,
                my_status: inbox,
                direct_request_state: 'accepted',
                can_manage_request: false,
            } : current);
            setMessage(inbox === 'general' ? t('chat.messageRequests.acceptedInGeneral') : t('chat.messageRequests.accepted'), 'success');
        } catch (err) {
            setMessage(errorMessage(err), 'error');
        }
    };

    const moveConversationInbox = async (inbox: 'principal' | 'general') => {
        if (!chatSelected) return;
        try {
            await api(token).put(`/chats/${chatSelected.chat_id}/inbox`, { inbox });
            invalidateChatListCache(user?.id);
            setChatSelected(current => current ? { ...current, my_status: inbox } : current);
            setMessage(inbox === 'general' ? t('chat.messageRequests.movedToGeneral') : t('chat.messageRequests.movedToPrincipal'), 'success');
        } catch (err) {
            setMessage(errorMessage(err), 'error');
        }
    };

    return (
        <>
            <Helmet>
                <title>Paçoca - Chat do Paçoca</title>
                <meta name="description" content={`Baixe o Paçoca, a rede social 100% brasileira!`} />
                <meta name="keywords" content={`Paçoca, rede social brasileira, Chat do Paçoca, premium, pagamento}`} />
                <meta name="author" content="Paçoca Inc." />
                <meta property="og:title" content={`Paçoca - Chat do Paçoca - Rede Social`} />
                <meta property="og:description" content={`Baixe o Paçoca, a rede social 100% brasileira!`} />
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`Paçoca - Chat do Paçoca - Rede Social`} />
                <meta name="twitter:description" content={`Baixe o Paçoca, a rede social 100% brasileira`} />
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>

            <ChatMenu
                chatSelected={chatSelected}
                show={showChatMenu}
                initialTab={chatMenuInitialTab}
                onClose={() => { setShowChatMenu(false); setChatMenuInitialTab(null); }}
                onNicknameChange={(nickname) => {
                    if (!chatSelected) return;
                    const patch = { nickname, name: nickname ?? chatSelected.original_name ?? chatSelected.name };
                    setChatSelected(prev => prev ? { ...prev, ...patch } : prev);
                    setMembers(prev => prev
                        ? prev.map(m => m.chat_id === chatSelected.chat_id ? { ...m, ...patch } : m)
                        : prev
                    );
                    invalidateChatListCache(user?.id);
                    setShowChatMenu(false);
                }}
                onScrollToMessage={(id) => {
                    setShowChatMenu(false);
                    scrollToMessage(id);
                }}
            />

            <NewConversationPanel
                show={showNewConversation}
                onClose={() => setShowNewConversation(false)}
                onNewGroup={() => setShowCreateGroup(true)}
            />

            <ForwardMessageModal
                show={showForwardModal}
                messages={messages}
                selectedIds={selectedMessages}
                members={members}
                onClose={() => setShowForwardModal(false)}
                onForward={handleForwardMessages}
            />

            <GroupInfoPanel
                show={showGroupInfo}
                initialTab={groupInfoInitialTab}
                onClose={() => { setShowGroupInfo(false); setGroupInfoInitialTab(null); }}
                chatSelected={chatSelected}
                onGroupUpdated={(updated) => {
                    invalidateChatListCache(user?.id);
                    setChatSelected(prev => prev ? { ...prev, ...updated } : prev);
                    setMembers(prev => prev
                        ? prev.map(m => m.chat_id === chatSelected?.chat_id ? { ...m, ...updated } : m)
                        : prev
                    );
                }}
                onLeft={() => {
                    invalidateChatListCache(user?.id);
                    setChatSelected(null);
                    setMembers(prev => prev ? prev.filter(m => m.chat_id !== chatSelected?.chat_id) : prev);
                    navigate("/chat");
                }}
                onScrollToMessage={(id) => {
                    setShowGroupInfo(false);
                    scrollToMessage(id);
                }}
            />

            <CreateGroupModal
                show={showCreateGroup}
                onClose={() => setShowCreateGroup(false)}
                onCreated={(chatId, groupName) => {
                    invalidateChatListCache(user?.id);
                    setShowCreateGroup(false);
                    navigate(`/chat/${chatId}`);
                }}
            />

            <ConfirmationModal
                show={showConfirmDeleteRequest}
                onClose={() => setShowConfirmDeleteRequest(false)}
                onConfirm={() => {
                    setShowConfirmDeleteRequest(false);
                    handleRequestAction('delete');
                }}
                title={t('chat.messageRequests.delete')}
                text={t('chat.messageRequests.deleteConfirm', { defaultValue: 'Are you sure you want to delete this message request?' })}
                requirePassword={false}
                setPassword={setPassword}
                errorMessage=""
                isLoading={false}
                idModal="modal-delete-message-request"
            />

            <ConfirmationModal
                show={showConfirmationDeleteMessage}
                onClose={() => onCloseDeleteMessage()}
                onConfirm={() => deleteMessages(false)}
                title={t("chat.deleteMessages")}
                text={t(selectedMessages.length === 1 ? "chat.deleteMessagesCount_one" : "chat.deleteMessagesCount_other", { count: selectedMessages.length })}
                requirePassword={false}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={""}
                isLoading={isLoadingDeleteMessage}
                closeRef={closeDeleteMessage}
                idModal="modal-delete-message"
            />

            <ConfirmationModal
                show={showConfirmationDeleteMessageForAll}
                onClose={() => onCloseDeleteMessageForAll()}
                onConfirm={() => deleteMessages(true)}
                title={t("chat.deleteMessagesForAll")}
                text={t(selectedMessages.length === 1 ? "chat.deleteMessagesCount_one" : "chat.deleteMessagesCount_other", { count: selectedMessages.length })}
                requirePassword={false}
                setPassword={setPassword} // Adicione a função setPassword aqui
                errorMessage={""}
                isLoading={isLoadingDeleteMessage}
                closeRef={closeDeleteMessage}
                idModal="modal-delete-message-for-all"
            />

            <ConfirmationModal
                show={showConfirmClearConversation}
                onClose={() => setShowConfirmClearConversation(false)}
                onConfirm={() => handleClearConversation()}
                title={t("chat.clearConversation")}
                text={t("chat.clearConversationWarning")}
                requirePassword={false}
                setPassword={setPassword}
                errorMessage={""}
                isLoading={isClearingConversation}
                idModal="modal-clear-conversation"
            />

            {isDrop ? (
                <div style={{ position: "absolute", top: "50%", right: "50%", transform: "translate(50%, -50%)", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 30, fontSize: 30 }}>
                    <Upload size={80}/>
                    {t("chat.dropToSend")}
                </div>
            ): null}

            <div ref={chatContent} className="row row-list-chat">
                <NavbarTop />
                <div className="menu-left-chat-pc">
                    <ul className="navbar-nav me-auto mb-lg-0" style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", width: "100%" }}>
                        <li className={`nav-link`}>
                            <Link className="nav-link" to="/" aria-label="Ir para home" style={{ padding: 0 }}>
                                <Home height={22} className={`icon-menu-dark`} style={{ padding: 0 }} />
                            </Link>
                        </li>
                        <li className={`nav-link`}>
                            <Link className="nav-link" to="/pesquisa" aria-label="Ir para pesquisa" style={{ padding: 0 }}>
                                <Search height={22} className={`icon-menu-dark`} style={{ padding: 0 }} />
                            </Link>
                        </li>
                        <li className={`nav-link`}>
                            <Link className="nav-link" to="/jogos" aria-label="Ir para home" style={{ padding: 0 }}>
                                <Gamepad2 height={22} className={`icon-menu-dark`} size={30} style={{ padding: 0 }} />
                            </Link>
                        </li>
                        <li className={`nav-link`}>
                            <Link className="nav-link" to="/comunidades" aria-label="Ir para tela de comunidades" style={{ padding: 0 }}>
                                <Users height={22} className="icon-menu-dark icon-group" data-feather="users" style={{ padding: 0 }} />
                            </Link>
                        </li>
                        <li className={`nav-link`}>
                            <Link aria-label="Ir para notificações" className="nav-link position-relative" to="/notificacoes" style={{ padding: 0 }}>
                                <Heart height={22} className={`icon-menu-dark icon-group`} style={{ padding: 0 }} />
                                {window.innerWidth > 850 ? (
                                    <NotificationBadge />
                                ) : null}
                            </Link>
                        </li>
                    </ul>
                    <li className={`nav-link user-selec-none`}>
                        <AddAccount setDropdownVisible={setDropdownVisible} isDropdownVisible={isDropdownVisible}/>
                    </li>
                </div>


                <div className="col-3 col-list-chat">
                    <div className=" list-chat row list-chat-pc list-chat-pc-trash">
                        <div className="d-flex justify-content-end align-items-center" style={{ gap: 2 }}>
                            {selectedMembers?.length ? (
                                <>
                                    {selectedMembers.length > 1 && (
                                        <span style={{ fontSize: 13, opacity: 0.7, marginRight: 4 }}>
                                            {t("chat.selected_other", { count: selectedMembers.length })}
                                        </span>
                                    )}
                                    <button
                                        className="icon-small-menu-top"
                                        onClick={async () => {
                                            if (!members || !selectedMembers.length) return;
                                            const allMuted = selectedMembers.every(id => members.find(m => m.chat_id === id)?.is_muted);
                                            const targetMuted = !allMuted;
                                            setMembers(prev => prev ? prev.map(m => selectedMembers.includes(m.chat_id) ? { ...m, is_muted: targetMuted } : m) : prev);
                                            const ids = [...selectedMembers];
                                            setSelectedMembers([]);
                                            for (const chatId of ids) {
                                                try { await api(token).patch(`${PACOCA_API_URL}/chats/${chatId}/mute`); } catch {}
                                            }
                                        }}
                                        aria-label={t("settings.muteConversation")}
                                        title={selectedMembers.every(id => members?.find(m => m.chat_id === id)?.is_muted) ? t("chat.unmuteNotifications") : t("chat.muteNotifications")}
                                        style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: -3, marginRight: 0 }}
                                        type="button"
                                    >
                                        {selectedMembers.every(id => members?.find(m => m.chat_id === id)?.is_muted)
                                            ? <Bell opacity={.6} size={20}/>
                                            : <BellOff opacity={.6} size={20}/>
                                        }
                                    </button>
                                    {selectedMembers.every(id => !members?.find(m => m.chat_id === id)?.is_group) && (
                                        <button className="icon-small-menu-top" onClick={() => setShowConfirmation(true)} aria-label={t("chat.deleteConversation")} style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: -3, marginRight: 0 }} type="button">
                                            <Trash2 opacity={.6} size={20}/>
                                        </button>
                                    )}
                                    <button className="icon-small-menu-top" onClick={() => setSelectedMembers([])} aria-label={t("chat.cancelSelection")} style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: -3 }} type="button">
                                        <X opacity={.6} size={23}/>
                                    </button>
                                </>
                            ) : (
                                <button
                                    className="icon-small-menu-top btn-create-group-pc"
                                    title={t("chat.newConversation")}
                                    type="button"
                                    onClick={() => setShowNewConversation(true)}
                                    style={{ border: 0, borderRadius: "5px", background: "transparent", marginTop: -3 }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity={0.6}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                </button>
                            )}
                        </div>
                    </div>
                    <div style={{ height: 15 }}></div>
                    <ChatList members={members} setMembers={setMembers} selectedChatId={chatSelected?.chat_id} intervalRef={intervalRef} cleanOpenChat={cleanOpenChat} setShowConfirmation={setShowConfirmation} showConfirmation={showConfirmation} selectedMessages={selectedMembers} setSelectedMessages={setSelectedMembers} onPacocaIAClick={() => changeChat(null)} onNotificationsTypeChange={(type) => { chatListTabRef.current = type; }}/>
                </div>

                <div className={`col col-conversa col-conversa-pc ${(selectedMessages.length > 0 && window.innerWidth > 850) || selectedMessages.length > 1 && "col-conversa-pc-select-message"}`} style={{ position: "relative" }}>
                    {showImagePreview && selectedFiles.length > 0 && (
                        <ChatImagePreview
                            files={selectedFiles}
                            caption={imagePreviewCaption}
                            isViewOnce={isViewOnce}
                            onToggleViewOnce={() => setIsViewOnce(prev => !prev)}
                            onChangeCaption={setImagePreviewCaption}
                            onConfirm={(editedFiles, viewOnce) => {
                                const caption = imagePreviewCaption.trim();
                                setShowImagePreview(false);
                                setImagePreviewCaption("");
                                setSelectedFiles([]);
                                handleSubmitMessage(caption || undefined, false, editedFiles, Boolean(viewOnce));
                            }}
                            onClose={() => {
                                setShowImagePreview(false);
                                setSelectedFiles([]);
                                setImagePreviewCaption("");
                                setIsViewOnce(false);
                            }}
                            onRemove={removeFile}
                            onAddMore={(newFiles) => setSelectedFiles(prev => [...prev, ...newFiles].slice(0, 10))}
                        />
                    )}
                    <div className="user-select-none list-chat title-chat list-chat-dark row chat-open-name" style={{ top: topPadding }}>
                        {(selectedMessages.length >= 1 && window.innerWidth <= 850) ? (
                            <div className="mobile-selection-bar">
                                <a className="close-chat none-pc" style={{ background: "transparent" }} onClick={() => setSelectedMessages([])}>
                                    <ChevronLeft className="img-menu-chat" />
                                </a>
                                <span className="mobile-selection-count">{selectedMessages.length}</span>
                                <div className="mobile-selection-actions">
                                    {selectedMessages.length === 1 && (
                                        <button title={t("chat.reply")} onClick={() => { const msg = messages.find(m => m.id == selectedMessages[0]); if(msg){ setReplyingTo(msg); setSelectedMessages([]); } }}>
                                            <Reply size={20}/>
                                        </button>
                                    )}
                                    {selectedMessages.length === 1 && messages.find(m => m.id == selectedMessages[0])?.text.trim().length ? (
                                        <button title={t("chat.copy")} onClick={() => copyText(messages.find(m => m.id == selectedMessages[0])?.text ?? "")}>
                                            <Clipboard size={20}/>
                                        </button>
                                    ) : null}
                                    {selectedMessages.length < 5 && (() => { const msg = messages.find(m => m.id == selectedMessages[0]); return msg ? (
                                        <button title={msg.is_favorited ? t("chat.unfavorite") : t("chat.favorite")} onClick={() => { handleFavoriteMessage(msg); setSelectedMessages([]); }}>
                                            <Star size={20} fill={msg.is_favorited ? "currentColor" : "none"}/>
                                        </button>
                                    ) : null; })()}
                                    {selectedMessages.length <= 3 && (() => { const msg = messages.find(m => m.id == selectedMessages[0]); return msg ? (
                                        <button title={msg.is_pinned ? t("chat.unpin") : t("chat.pin")} onClick={() => { handlePinMessage(msg); setSelectedMessages([]); }}>
                                            <Pin size={20} strokeWidth={msg.is_pinned ? 2.5 : 1.5}/>
                                        </button>
                                    ) : null; })()}
                                    <button title={t("chat.forward")} onClick={() => setShowForwardModal(true)}>
                                        <Forward size={20}/>
                                    </button>
                                    <button title={t("chat.deleteMessages")} onClick={() => setShowConfirmationDeleteMessage(true)}>
                                        <Trash size={20}/>
                                    </button>
                                    {messages.filter(m => selectedMessages.includes(m.id)).every(m => m.user_id === user?.id) && (
                                        <button title={t("chat.deleteMessagesForAll")} onClick={() => setShowConfirmationDeleteMessageForAll(true)}>
                                            <Trash2 size={20}/>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ) : null}
                        <div className="col-1 col-image-chat" style={{ display: selectedMessages.length >= 1 && window.innerWidth <= 850 ? "none" : "flex", alignItems: "center" }}>
                            <a className="close-chat none-pc" style={{ background: "transparent" }} onClick={() => selectedMessages.length <= 0 ? navigate("/chats") : setSelectedMessages([])}>
                                {selectedMessages.length <= 0 ? <ChevronLeft className="img-menu-chat" /> : <X className="img-menu-chat" />}
                            </a>

                                {(!chatSelected?.user_name && !chatSelected?.is_group && !loadingMessages) && (
                                    <>
                                    <div className="dropdown">
                                        {chatSelected?.user_name || (loadingMessages ? "" : (
                                            <>
                                               
                                                <div  data-bs-toggle="dropdown" style={{ position: "relative" }}>
                                                    <img style={{ visibility: selectedMessages.length > 0 && window.innerWidth <= 850 ? "hidden" : "visible" }} src={selectedIa.img_account} className="user-select-none img-list-chat" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                                    <div className="active-user-chat"></div>
                                                </div>

                                                <ul className="dropdown-menu">
                                                    {ias.map((ia) => (
                                                        <li key={ia.id}>
                                                            <button
                                                                className="dropdown-item d-flex align-items-center gap-2"
                                                                onClick={() => setSelectedIa(ia)}
                                                            >
                                                                <img src={ia.img_account} width="24" height="24" className="rounded-circle" />
                                                                {ia.name}
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        ))}
                                    </div>
                                    </>
                                )}

                            {(selectedMessages.length > 1 || (selectedMessages.length > 0 && window.innerWidth > 850)) || !chatSelected || window.innerWidth > 850 ? (
                                <></>
                            ) : chatSelected.is_group ? (
                                <div style={{ position: "relative", cursor: "pointer" }} onClick={() => setShowGroupInfo(true)}>
                                    {chatSelected.group_img ? (
                                        <img style={{ visibility: (selectedMessages.length > 1 || (selectedMessages.length > 0 && window.innerWidth > 850)) ? "hidden" : "visible" }} src={getImageUser(chatSelected.group_img)} className="user-select-none img-list-chat" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                    ) : (
                                        <div className="user-select-none img-list-chat group-avatar-placeholder" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--hover-background,#e0e0e0)", borderRadius: "50%", flexShrink: 0, visibility: (selectedMessages.length > 1 || (selectedMessages.length > 0 && window.innerWidth > 850)) ? "hidden" : "visible" }}>
                                            <Users size={20} opacity={0.6} />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div style={{ position: "relative" }}>
                                    <img style={{ visibility: (selectedMessages.length > 1 || (selectedMessages.length > 0 && window.innerWidth > 850)) ? "hidden" : "visible" }} onClick={chatSelected?.name && !loadingMessages ? () => setShowChatMenu(true) : undefined} src={`${chatSelected ? getImageUser(chatSelected?.img_account) : (!loadingMessages ? "/img/pacoca_ai.png" : "img/img-account.png")}`} className="user-select-none img-list-chat" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                    {(!chatSelected || chatSelected.is_online) && (
                                        <div className="active-user-chat"></div>
                                    )}
                                </div>
                            )}

                            {(selectedMessages.length > 0 && window.innerWidth > 850) ? (
                                <div className="menu-selecao">
                                    <div className="d-flex" style={{alignItems: "center"}}>
                                        <button className="none-cel x-chat" onClick={() => setSelectedMessages([])}><X/></button>
                                        {t("chat.selected_one", { count: selectedMessages.length })}

                                        <div className="selection-toolbar">
                                            {selectedMessages.length === 1 && (
                                                <button title={t("chat.reply")} onClick={() => { const msg = messages.find(m => m.id == selectedMessages[0]); if(msg){ setReplyingTo(msg); setSelectedMessages([]); } }}>
                                                    <Reply size={18}/>
                                                </button>
                                            )}
                                            {selectedMessages.length === 1 && messages.find(m => m.id == selectedMessages[0])?.text.trim().length ? (
                                                <button title={t("chat.copy")} onClick={() => copyText(messages.find(m => m.id == selectedMessages[0])?.text ?? "")}>
                                                    <Clipboard size={18}/>
                                                </button>
                                            ) : null}
                                            {selectedMessages.length < 5 && (() => { const msg = messages.find(m => m.id == selectedMessages[0]); return msg ? (
                                                <button title={msg.is_favorited ? t("chat.unfavorite") : t("chat.favorite")} onClick={() => { handleFavoriteMessage(msg); setSelectedMessages([]); }}>
                                                    <Star size={18} fill={msg.is_favorited ? "currentColor" : "none"}/>
                                                </button>
                                            ) : null; })()}
                                            {selectedMessages.length <= 3 && (() => { const msg = messages.find(m => m.id == selectedMessages[0]); return msg ? (
                                                <button title={msg.is_pinned ? t("chat.unpin") : t("chat.pin")} onClick={() => { handlePinMessage(msg); setSelectedMessages([]); }}>
                                                    <Pin size={18} strokeWidth={msg.is_pinned ? 2.5 : 1.5}/>
                                                </button>
                                            ) : null; })()}
                                            <button title={t("chat.forward")} onClick={() => setShowForwardModal(true)}>
                                                <Forward size={18}/>
                                            </button>
                                            <button title={t("chat.deleteMessages")} onClick={() => setShowConfirmationDeleteMessage(true)}>
                                                <Trash size={18}/>
                                            </button>
                                            {messages.filter(m => selectedMessages.includes(m.id)).every(m => m.user_id === user?.id) && (
                                                <button title={t("chat.deleteMessagesForAll")} onClick={() => setShowConfirmationDeleteMessageForAll(true)}>
                                                    <Trash2 size={18}/>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {/* <a className="icon-menu-chat none-pc" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
                                        <Menu className="img-menu-chat" />
                                    </a> */}
                                </>
                            )}

                        </div>

                        {((selectedMessages.length > 0 && window.innerWidth > 850) || (chatId && !isAiConvId(chatId) && !chatSelected?.name)) ? (
                            <div className={`col ${selectedMessages.length > 0 ? "none-cel" : ""}`} style={{ display: selectedMessages.length > 0 && window.innerWidth <= 850 ? "none" : undefined }}>
                                <h4 className="pc" id="chat-name"> &nbsp; </h4>
                                <p className="pc" id="chat-name"></p>
                            </div>
                        ): (
                            <>
                             {(!chatSelected?.user_name && !chatSelected?.is_group && !loadingMessages) && selectedMessages.length === 0 && (
                                    <>
                                        <div className="d-flex align-items-center" style={{ marginLeft: -10, gap: 6 }}>
                                            <div className="dropdown">
                                                {chatSelected?.user_name || (loadingMessages ? "" : (
                                                    <>
                                                        <div data-bs-toggle="dropdown" className={`col ${selectedMessages.length > 0 ? "none-cel" : ""}`}>
                                                            <div style={{ position: "relative" }}>
                                                                <h4 className="pc" id="chat-name">{chatSelected?.name || (loadingMessages ? "" : selectedIa.name)} </h4>
                                                                <p className="pc" id="chat-name">{chatSelected?.user_name || !loadingMessages ? "@" : ""}{chatSelected?.user_name || (loadingMessages ? "" : selectedIa.user_name)} <ChevronDown style={{ marginTop: -20, opacity: .7, marginLeft: 0 }}/></p>
                                                            </div>
                                                        </div>

                                                        <ul className="dropdown-menu">
                                                            {ias.map((ia) => (
                                                                <li key={ia.id}>
                                                                    <button
                                                                        className="dropdown-item d-flex align-items-center gap-2"
                                                                        onClick={() => setSelectedIa(ia)}
                                                                    >
                                                                        <img src={ia.img_account} width="24" height="24" className="rounded-circle" />
                                                                        {ia.name}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                ))}
                                            </div>
                                            <button
                                                type="button"
                                                className="ai-conv-toggle-btn"
                                                title="Histórico de conversas"
                                                onClick={() => setShowAiConvList(v => !v)}
                                            >
                                                <Menu size={19} />
                                            </button>
                                        </div>
                                    </>
                                )}

                                <div
                                    className={`offcanvasExample-chat col ${selectedMessages.length > 0 ? "none-cel" : ""}`}
                                    style={{ ...(selectedMessages.length > 0 ? { display: "none" } : {}), ...(!loadingMessages ? { cursor: "pointer" } : {}) }}
                                    onClick={!loadingMessages ? (chatSelected?.name ? (chatSelected.is_group ? () => setShowGroupInfo(true) : () => setShowChatMenu(true)) : () => setShowAiConvList(v => !v)) : undefined}
                                >
                                    {chatSelected && (
                                        <>
                                            <div ref={headerMenuRef} className="chat-header-menu-wrap" style={{ position: "absolute", right: 17 }}>
                                                <button
                                                    type="button"
                                                    className="ai-conv-toggle-btn"
                                                    title="Opções"
                                                    style={{ position: "static" }}
                                                    onClick={(e) => { e.stopPropagation(); setShowHeaderMenu(v => !v); }}
                                                >
                                                    <MoreVertical size={19} />
                                                </button>
                                                {showHeaderMenu && (
                                                    <div className="chat-header-dropdown">
                                                        {chatSelected.is_group ? (
                                                            <>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setGroupInfoInitialTab(null); setShowGroupInfo(true); }}>
                                                                    <Info size={15} />{t("chat.viewGroup")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setGroupInfoInitialTab("media"); setShowGroupInfo(true); }}>
                                                                    <Image size={15} />{t("chat.group.mediaLinksTitle")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setGroupInfoInitialTab("search"); setShowGroupInfo(true); }}>
                                                                    <Search size={15} />{t("chat.group.searchMessages")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setGroupInfoInitialTab("favorites"); setShowGroupInfo(true); }}>
                                                                    <Star size={15} />{t("chat.favorites")}
                                                                </button>
                                                                {pinnedMessages.length > 0 && (
                                                                    <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setShowPinnedBanner(true); }}>
                                                                        <Pin size={15} />{t("chat.pinnedCount", { count: pinnedMessages.length })}
                                                                    </button>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setChatMenuInitialTab(null); setShowChatMenu(true); }}>
                                                                    <UserIcon size={15} />{t("chat.viewContact")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setChatMenuInitialTab("nickname"); setShowChatMenu(true); }}>
                                                                    <Pencil size={15} />{t("chat.nickname")}
                                                                </button>
                                                                {chatSelected.direct_request_state !== 'pending' && chatSelected.direct_request_state !== 'rejected' ? (
                                                                    <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); moveConversationInbox(chatSelected.my_status === 'general' ? 'principal' : 'general'); }}>
                                                                        <MessageCircle size={15} />{chatSelected.my_status === 'general' ? t('chat.messageRequests.moveToPrincipal') : t('chat.messageRequests.moveToGeneral')}
                                                                    </button>
                                                                ) : null}
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setChatMenuInitialTab("media"); setShowChatMenu(true); }}>
                                                                    <Image size={15} />{t("chat.group.mediaLinksTitle")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setChatMenuInitialTab("search"); setShowChatMenu(true); }}>
                                                                    <Search size={15} />{t("chat.group.searchMessages")}
                                                                </button>
                                                                <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setChatMenuInitialTab("favorites"); setShowChatMenu(true); }}>
                                                                    <Star size={15} />{t("chat.favorites")}
                                                                </button>
                                                                {pinnedMessages.length > 0 && (
                                                                    <button className="chat-header-dropdown-item" onClick={() => { setShowHeaderMenu(false); setShowPinnedBanner(true); }}>
                                                                        <Pin size={15} />{t("chat.pinnedCount", { count: pinnedMessages.length })}
                                                                    </button>
                                                                )}
                                                            </>
                                                        )}
                                                        <button className="chat-header-dropdown-item chat-header-dropdown-item--danger" onClick={() => { setShowHeaderMenu(false); setShowConfirmClearConversation(true); }}>
                                                            <Trash2 size={15} />{t("chat.clearConversation")}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: 1 }}>
                                                {chatSelected.is_group ? (
                                                    chatSelected.group_img ? (
                                                        <img src={getImageUser(chatSelected.group_img)} className="user-select-none img-list-chat none-cel" style={{ flexShrink: 0 }} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                                    ) : (
                                                        <div className="user-select-none img-list-chat group-avatar-placeholder none-cel" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "var(--hover-background,#e0e0e0)", borderRadius: "50%", flexShrink: 0 }}>
                                                            <Users size={20} opacity={0.6} />
                                                        </div>
                                                    )
                                                ) : (
                                                    <div className="none-cel" style={{ position: "relative", flexShrink: 0 }}>
                                                        <img src={chatSelected ? getImageUser(chatSelected.img_account) : "/img/pacoca_ai.png"} className="user-select-none img-list-chat" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
                                                        {chatSelected.is_online && <div className="active-user-chat"></div>}
                                                    </div>
                                                )}
                                                <div style={{ minWidth: 0, flex: 1 }}>
                                                    <h4 className="pc" id="chat-name">{chatSelected.is_group ? (chatSelected.group_name ?? t("chat.group.panelTitle")) : (chatSelected?.name || (loadingMessages ? "" : selectedIa.name))}</h4>
                                                    {recordingUserNames.length > 0 ? (
                                                        <span className="chat-typing-status chat-recording-status">
                                                            {chatSelected.is_group ? `${recordingUserNames.join(", ")} está gravando áudio` : "gravando áudio"}
                                                        </span>
                                                    ) : typingUserNames.length > 0 ? (
                                                        <span className="chat-typing-status">
                                                            {chatSelected.is_group ? `${typingUserNames.join(", ")} está digitando` : "digitando"}
                                                        </span>
                                                    ) : (!chatSelected.is_group && <p className="pc" id="chat-name">{chatSelected?.user_name || !loadingMessages ? "@" : ""}{chatSelected?.user_name || (loadingMessages ? "" : selectedIa.user_name)}</p>)}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </>
                        )}
                    </div>

                    <div
                        id="row-chat-conteudo"
                        ref={rowChatRef}
                        className="row overflow-minus"
                        style={{ overflow: "auto" }}
                        onScroll={updateScrollToBottomVisibility}
                    >
                        <div id="chat-conteudo" ref={messagesContentRef} className="chat" onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
                            {chatSelected ? (
                                <>
                                    {/* Pinned messages banner */}
                                    {pinnedMessages.length > 0 && (
                                        <div className="pinned-banner">
                                            <div className="pinned-banner-header" onClick={() => setShowPinnedBanner(v => !v)}>
                                                <Pin size={14} />
                                                <span>{t("chat.pinnedCount", { count: pinnedMessages.length })}</span>
                                                <span className="pinned-banner-chevron">{showPinnedBanner ? "▲" : "▼"}</span>
                                            </div>
                                            {showPinnedBanner && (
                                                <div className="pinned-banner-list">
                                                    {pinnedMessages.map((pin) => pin.message && (
                                                        <div key={pin.id} className="pinned-banner-item" onClick={() => { scrollToMessage(pin.chat_message_id); setShowPinnedBanner(false); }}>
                                                            <div className="pinned-banner-text">
                                                                <span className="pinned-banner-user">{pin.message.user?.name ?? t("generics.user")}</span>
                                                                <span className="pinned-banner-msg">
                                                                    {pin.message.text?.trim()
                                                                        ? pin.message.text.slice(0, 80)
                                                                        : pin.message.gif_url
                                                                            ? "GIF"
                                                                            : pin.message.file_path && JSON.parse(pin.message.file_path).length > 0
                                                                                ? t("chat.message.file")
                                                                                : "…"}
                                                                </span>
                                                            </div>
                                                            {(chatSelected.is_admin || !chatSelected.is_group) && (
                                                                <button
                                                                    className="pinned-banner-unpin"
                                                                    onClick={(e) => { e.stopPropagation(); if (pin.message) handlePinMessage(pin.message); }}
                                                                    title={t("chat.unpin")}
                                                                >
                                                                    <PinOff size={13}/>
                                                                </button>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {!loadingMessages && messages.length <=0 && (
                                        <div className="user-select-none row" style={{ marginTop: "24px", width: "100%", marginLeft: "0", marginRight: "0" }}>
                                            <span className="span-empty" style={{width: "100%", marginTop: "250px"}}>
                                                <MessageCircle className="icon-empty" />
                                                <h3 className="w-100 text-center">{t("chat.sendAMessage")}</h3>
                                            </span>
                                        </div>
                                    )}

                                    {messages?.map((m, index) => {
                                        const paths = parseMessageFileList(m.file_path);
                                        const types = parseMessageFileList(m.file_type);
                                        const names = parseMessageFileList(m.file_name);

                                        const prevMsg = messages[index - 1];
                                        const showDateSep = !prevMsg || new Date(m.created_at).toDateString() !== new Date(prevMsg.created_at).toDateString();
                                        const isSystemMessage = m.message_type === "system";
                                        const isExternalSender = !isSystemMessage && String(m.user_id) !== String(chatSelected.user_id) && String(m.user_id) !== String(user?.id);
                                        const showSender = isExternalSender && (
                                            !prevMsg
                                            || String(prevMsg.user_id) !== String(m.user_id)
                                            || showDateSep
                                        );

                                        return (
                                            <React.Fragment key={index}>
                                            {showDateSep && (
                                                <div className="chat-date-separator">
                                                    <span>{getDateLabel(m.created_at)}</span>
                                                </div>
                                            )}
                                            {isSystemMessage ? (
                                                <ChatSystemMessage message={m} isOwn={String(m.user_id) === String(user?.id)} />
                                            ) : (
                                            <MessageChatComponent
                                                m={m}
                                                user={user}
                                                isOwnMessage={m.user_id == user?.id}
                                                onPressStart={onPressStart}
                                                onPressEnd={onPressEnd}
                                                onPressMove={onPressMove}
                                                selectedMessages={selectedMessages}
                                                chatSelected={chatSelected}
                                                setSelectedMessages={setSelectedMessages}
                                                types={types}
                                                paths={paths}
                                                closeDropdown={closeDropdown}
                                                edit={edit}
                                                isTextLong={isTextLong}
                                                isExpanded={isExpanded}
                                                toggleExpand={toggleExpand}
                                                formatarData={formatarData}
                                                names={names}
                                                openImage={openImage}
                                                setOpenImage={setOpenImage}
                                                setShowConfirmationDeleteMessage={setShowConfirmationDeleteMessage}
                                                setShowConfirmationDeleteMessageForAll={setShowConfirmationDeleteMessageForAll}
                                                setReplyingTo={setReplyingTo}
                                                highlightedMessageId={highlightedMessageId}
                                                scrollToMessage={scrollToMessage}
                                                onReactMessage={handleReactMessage}
                                                onMessageUpdated={(updatedMsg) => {
                                                    setMessages(prev => prev.map(m => m.id === updatedMsg.id ? updatedMsg : m));
                                                    const stored = localStorage.getItem(`messagesByChat-${user?.id}`);
                                                    const map = stored ? JSON.parse(stored) : {};
                                                    if (chatSelected?.chat_id && map[chatSelected.chat_id]) {
                                                        map[chatSelected.chat_id] = map[chatSelected.chat_id].map((m: MessageChat) => m.id === updatedMsg.id ? updatedMsg : m);
                                                        localStorage.setItem(`messagesByChat-${user?.id}`, JSON.stringify(map));
                                                    }
                                                }}
                                                onPinMessage={handlePinMessage}
                                                onFavoriteMessage={handleFavoriteMessage}
                                                canPin={!chatSelected.is_group || !!chatSelected.is_admin}
                                                showSender={showSender}
                                            />
                                            )}
                                            </React.Fragment>
                                        );
                                    })}

                                    {(recordingPresenceUsers.length > 0 || typingPresenceUsers.length > 0) && (
                                            <ChatLivePresence
                                                users={recordingPresenceUsers.length > 0 ? recordingPresenceUsers : typingPresenceUsers}
                                                recording={recordingPresenceUsers.length > 0}
                                                isGroup={!!chatSelected.is_group}
                                                fallbackImage={!chatSelected.is_group ? chatSelected.img_account : undefined}
                                            />
                                    )}

                                </>
                            ) : (
                                <>
                                    {loadingMessages ? (
                                        <div className="d-flex mt-3 w-100" style={{ justifyContent: "center" }}>
                                            <LoadingThreeCircle/>
                                        </div>
                                    ) : (
                                        <>
                                        {chatId && !chatSelected && !isAiConvId(chatId) ? (
                                            <div className="user-select-none row" style={{ marginTop: "24px", width: "100%", marginLeft: "0", marginRight: "0" }}>
                                                <span className="span-empty" style={{width: "100%", marginTop: "250px"}}>
                                                    <MessageCircle className="icon-empty" />
                                                    <h3 className="w-100 text-center">{t("chat.errorLoadChat")}</h3>
                                                </span>
                                            </div>
                                        ) : (
                                           <>
                                             <div className="div-text-chat">
                                                <div className="text-user-nao-logado">
                                                    <p>{t(`${selectedIa.id == 2 ? "bochechaAI" : "pacocaAI"}.text1`)}</p>
                                                </div>
                                            </div>
                                            <div className="div-text-chat">
                                                <div className="text-user-nao-logado">
                                                    <p>{t(`${selectedIa.id == 2 ? "bochechaAI" : "pacocaAI"}.text2`)}</p>
                                                </div>
                                            </div>
                                            <div className="div-text-chat">
                                                <div className="text-user-nao-logado">
                                                    <p>{t(`${selectedIa.id == 2 ? "bochechaAI" : "pacocaAI"}.text3`)}</p>
                                                </div>
                                            </div>
                                            <div className="div-text-chat">
                                                <div className="text-user-nao-logado">
                                                    <p>{t(`${selectedIa.id == 2 ? "bochechaAI" : "pacocaAI"}.text4`)}</p>
                                                </div>
                                            </div>
                                            {/* <div className="div-text-chat">
                                                <div className="text-user-nao-logado">
                                                    <p>As mensagens são excluidas a cada 24 horas.</p>
                                                </div>
                                            </div> */}

                                            {messages?.map((m, index) => {
                                                return (
                                                    <div key={index} className={`div-text-chat ${m.user_id == user?.id ? "div-text-chat-logado" : ""}`}>
                                                        <div className={`${m.user_id == user?.id ? "text-user-logado" : "text-user-nao-logado"}`}>
                                                            {loadingIAResponse && idCurrentIAResponse == m.id  ? (
                                                                <div className="typing-indicator">
                                                                    <span></span>
                                                                    <span></span>
                                                                    <span></span>
                                                                </div>
                                                            ) : (
                                                                <AiMessageContent text={m.text} />
                                                            )}
                                                            <p className="data-mensagem">{formatarData(m.created_at)}</p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                           </>
                                        )}
                                        </>
                                    )}
                                </>
                            )}

                            <div ref={endChatRef}></div>
                        </div>
                    </div>

                        <>
                                <div
                                    className={`col${chatSelected?.can_manage_request ? " message-request-compose" : ""}`}
                                    id="form-escrever-chat"
                                    style={{ paddingBottom: chatSelected?.can_manage_request ? 0 : bottomPadding + 10, background: "var(--background-post)" }}
                                >
                                    {showScrollToBottom && (
                                        <button
                                            className="chat-scroll-to-bottom"
                                            type="button"
                                            aria-label={t('chat.conversation.goToEnd', { defaultValue: 'Ir para o fim da conversa' })}
                                            onClick={() => scrollToBottomAfterLayout('smooth')}
                                        >
                                            <ChevronsDown size={20} />
                                        </button>
                                    )}
                                    {/* Locked group bar — non-admins cannot post */}
                                    {chatSelected?.is_group && chatSelected?.only_admin_post && !chatSelected?.is_admin ? (
                                        <div className="group-locked-bar">
                                            <Lock size={14} />
                                            {t("chat.onlyAdminsCanSend")}
                                        </div>
                                    ) : null}
                                    {messages.length === 0 && !loadingIAResponse && !chatSelected?.is_group && !chatSelected && chatId?.includes("-") && (
                                    <div className="ai-suggestions">
                                        {aiSuggestions.map((suggestion) => (
                                            <button
                                                key={suggestion}
                                                className="ai-suggestion-chip"
                                                onClick={() => handleSubmitMessagePacocaAI(suggestion)}
                                            >
                                                {suggestion}
                                            </button>
                                        ))}
                                    </div>
                                )}
                                <form
                                    id="form-chat"
                                    className={`form-chat${chatSelected?.is_group && chatSelected?.only_admin_post && !chatSelected?.is_admin ? " form-chat-disabled" : ""}${chatSelected?.can_manage_request ? " message-request-form" : ""}`}
                                    method="POST"
                                    action="/send-message-chat"
                                >
                                    {chatSelected?.can_manage_request ? (
                                        <div className="message-request-footer" style={{ paddingBottom: bottomPadding + 12 }}>
                                            <div className="message-request-info">
                                                <Info size={18} aria-hidden="true" />
                                                <div>
                                                    <strong>{t('chat.messageRequests.pending')}</strong>
                                                    <span>{t('chat.messageRequests.banner')}</span>
                                                </div>
                                            </div>
                                            <button type="button" className="message-request-accept" onClick={() => handleRequestAction('accept')}>
                                                {t('chat.messageRequests.accept')}
                                            </button>
                                            <div className="message-request-secondary-actions">
                                                <button type="button" className="message-request-text-action" onClick={() => handleRequestAction('general')}>
                                                    <Inbox size={16} aria-hidden="true" />
                                                    {t('chat.messageRequests.acceptInGeneral')}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="message-request-text-action"
                                                    onClick={() => setShowConfirmDeleteRequest(true)}
                                                    aria-label={t('chat.messageRequests.delete')}
                                                >
                                                    <Trash2 size={16} aria-hidden="true" />
                                                    {t('chat.messageRequests.delete')}
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {(showAiLimitBanner && !chatSelected) || (aiLimitBannerName && !!chatSelected) ? (
                                                <AiLimitBanner aiName={selectedIa.name} />
                                            ) : null}

                                    {selectedMessages.length ? (
                                        <div className="none-pc" style={{width: "100%"}}>
                                        {/* <div className="d-flex" style={{gap: "10px", width: "100%", margin: "0!important"}}>
                                            <button className="btn btn-outline-danger trash-chat" style={{width: messages.filter(m => selectedMessages.includes(m.id)).every(m => m.user_id === user?.id) ? "calc(50% - 5px)" : "100%"}} onClick={() => { setShowConfirmationDeleteMessage(true); }}>
                                                <Trash2/> Apagar para mim
                                            </button>

                                            {selectedMessages.length > 0 && 
                                                messages.filter(m => selectedMessages.includes(m.id)).every(m => m.user_id === user?.id) && (
                                                    <button className="btn btn-danger trash-chat" style={{width: "calc(50% - 5px)"}} onClick={() => { setShowConfirmationDeleteMessageForAll(true); }} >
                                                        <Trash2 /> Apagar para todos
                                                    </button>
                                                )}
                                        </div> */}
                                            
                                        </div>
                                    ) : (
                                        <>
                                            {replyingTo && (
                                                <div className="reply-preview-bar">
                                                    <div className="reply-preview-accent" />

                                                    <div className="reply-preview-content">
                                                        <span className="reply-preview-name">
                                                            {replyingTo.user_id === user?.id ? t("chat.you") : (replyingTo.user?.name ?? "Mensagem")}
                                                        </span>
                                                        <span className="reply-preview-msg">
                                                            {replyingTo.is_view_once
                                                                ? "Visualização única"
                                                                : replyingTo.gif_url
                                                                    ? "🖼️ GIF"
                                                                    : replyingTo.file_path && JSON.parse(replyingTo.file_path).length > 0
                                                                        ? (() => {
                                                                            const mime = JSON.parse(replyingTo.file_type ?? "[]")[0] ?? "";
                                                                            if (mime.startsWith("image")) return `📷 ${t("chat.message.image")}`;
                                                                            if (mime.startsWith("video")) return `🎥 ${t("chat.message.video")}`;
                                                                            if (mime.startsWith("audio")) return `🎤 ${t("chat.message.audio")}`;
                                                                            return `📎 ${t("chat.message.file")}`;
                                                                        })()
                                                                        : replyingTo.text.slice(0, 80)}
                                                        </span>
                                                    </div>

                                                    {!replyingTo.is_view_once &&
                                                        replyingTo.file_path &&
                                                        JSON.parse(replyingTo.file_path).length > 0 &&
                                                        JSON.parse(replyingTo.file_type ?? "[]")[0]?.startsWith("image") && (
                                                            <img
                                                                className="reply-preview-thumb"
                                                                src={
                                                                    JSON.parse(replyingTo.file_path)[0].includes("blob:")
                                                                        ? JSON.parse(replyingTo.file_path)[0]
                                                                        : getImagePath(JSON.parse(replyingTo.file_path)[0])
                                                                }
                                                                alt=""
                                                            />
                                                        )}

                                                    <button type="button" className="foc-pc-close" onClick={cancelReply}>
                                                        <X size={15} />
                                                    </button>
                                                </div>
                                            )}
                                            <div className="col col-textarea-chat">
                                                 <div className="d-flex" style={{position: "relative"}}>
                                                     {/* Document/file previews only — images/videos use the fullscreen overlay */}
                                                     {selectedFiles.some(f => !f.file.type.startsWith("image") && !f.file.type.startsWith("video")) && (
                                                        <div className="preview-selected-files">
                                                            {selectedFiles.filter(f => !f.file.type.startsWith("image") && !f.file.type.startsWith("video")).map((file, index) => (
                                                                <div key={index} className="preview-item file">
                                                                    <div className="d-flex gap-1" style={{alignItems: "center"}}>
                                                                        {file.file.type.endsWith("excel") && <img className="img-type-file-chat" src="/img/icon/excel.png" alt="" /> }
                                                                        {file.file.type.endsWith("pdf") && <img className="img-type-file-chat" src="/img/icon/pdf.png" alt="" /> }
                                                                        {file.file.type.includes("word") && <img className="img-type-file-chat" src="/img/icon/word.png" alt="" /> }
                                                                        {file.file.type.includes("audio") && <img className="img-type-file-chat" src="/img/icon/audio.png" alt="" /> }
                                                                        {!file.file.type.endsWith("excel") && !file.file.type.includes("audio") && !file.file.type.includes("word") && !file.file.type.endsWith("pdf") && <img className="img-type-file-chat" src="/img/icon/file.file.png" alt="" /> }
                                                                        <p className="preview-text">{file.file.name}</p>
                                                                    </div>
                                                                    <button className="btn btn-remove-file" onClick={() => removeFile(selectedFiles.indexOf(file))}><Trash2/></button>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    { recording ? (
                                                        <>
                                                        
                                                        <div className="wpp-recording-bar">
                                                            {/* Esquerda: botão cancelar (PC/locked) ou hint de arrastar (mobile) */}
                                                            {(recordingLocked || window.innerWidth > 850) ? (
                                                                <button type="button" className="wpp-btn-action wpp-btn-cancel" onClick={cancelRecording}>
                                                                    <Trash2 size={20} />
                                                                </button>
                                                            ) : (
                                                                <div
                                                                    className="wpp-cancel-hint"
                                                                    style={{ opacity: Math.min(1, Math.abs(micDragX) / 0 + 0.35) }}
                                                                >
                                                                    <ChevronLeft size={13} />
                                                                    <span>{t("generics.cancel")}</span>
                                                                </div>
                                                            )}

                                                            {/* Centro: ponto piscando + timer + onda animada */}
                                                            <div
                                                                className="wpp-timer-area"
                                                                style={{
                                                                    transform: (!recordingLocked && window.innerWidth <= 850)
                                                                        ? `translateX(${micDragX * 0.25}px)`
                                                                        : undefined,
                                                                    transition: 'transform 0.05s linear',
                                                                }}
                                                            >
                                                                <span className="wpp-rec-dot" />
                                                                <span className="wpp-rec-time">{formatTime(recordingTime)}</span>
                                                                <div className="wpp-wave">
                                                                    {Array.from({ length: (recordingLocked || window.innerWidth > 850) ? 30 : 20 }).map((_, i) => (
                                                                        <span key={i} className="wpp-wave-bar" style={{ animationDelay: `${i * 0.09}s` }} />
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            {/* Direita: botão enviar (PC/locked) */}
                                                            {(recordingLocked || window.innerWidth > 850) && (
                                                                <button
                                                                    type="button"
                                                                    disabled={recordingTime < 1}
                                                                    className="btn btn-blue button-submit-chat btn-withou-shadow"
                                                                    onClick={() => { stopRecording(true); setRecordingLocked(false); }}
                                                                >
                                                                    <Send size={20} />
                                                                </button>
                                                            )}
                                                        </div>

                                                        </> 
                                                    ) : (
                                                        <>
                                                            <div className={`user-select-none btn-emoji-chat ${selectedFiles.length ? "btn-emoji-chat-with-files" : ""}`}>
                                                                <div className="cursor-pointer div-emoji-chat" onClick={() => setShowEmoji(true)}>
                                                                    <Smile className='icon-add-emoji' />
                                                                </div>
                                                            </div>
                                                            <textarea
                                                               rows={1}
                                                               value={text}
                                                               ref={textareaRef}
                                                               onPaste={handlePaste}
                                                               className={`textarea-chat form-control text-comment me-2 ${selectedFiles.length ? "btn-emoji-chat-with-files" : ""}`}
                                                               placeholder={chatSelected?.is_group && chatSelected?.only_admin_post && !chatSelected?.is_admin ? t("chat.onlyAdminsCanWrite") : (chatSelected ? t("chat.typeMessage") : t("chat.chatWith", { name: selectedIa.name }))}
                                                               required
                                                               disabled={!!(chatSelected?.can_manage_request || (chatSelected?.is_group && chatSelected?.only_admin_post && !chatSelected?.is_admin))}
                                                               onChange={(e) => handleInputTextarea(e)}
                                                               onKeyDown={(e) => handleKeyDown(e)}
                                                               onFocus={(e) => { setIsFocusText(true); } }
                                                               onBlur={() => { setIsFocusText(false); } }
                                                               style={{ background: "transparent!important" }}
                                                           />

                                                            <EmojiPickerNative
                                                                show={showEmoji} 
                                                                setShow={setShowEmoji} 
                                                                onSelect={(emoji) => { 
                                                                    if(emoji.startsWith(":f"))
                                                                        handleClickSticky(emoji);    
                                                                    else
                                                                        setText(prev => prev + emoji); 
                                                                }}  
                                                                handleClickGif={handleClickGif}
                                                                bottom={bottomPadding + parseFloat(textareaRef.current?.style.height || '0') + (window.innerWidth <=850 ? 10 : 10)}
                                                            />
                                                            <PreviewSearch 
                                                                textareaRef={textareaRef} 
                                                                text={text} 
                                                                setText={setText}
                                                                bottom={bottomPadding + parseFloat(textareaRef.current?.style.height || '0') + (window.innerWidth <=850 ? 10 : 10)}
                                                            />
                                                            {chatSelected ? (
                                                                <>
                                                                    <div className={`dicon-add-sticky div-file-chat ${text.trim().length ? "hide-icons" : ""}`}>
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            id="file"
                                                                            accept=".pdf,.doc,.docx,.txt"
                                                                            ref={fileInputRef}
                                                                            style={{ display: "none" }}
                                                                            onChange={handleFilesChange}
                                                                        />
                                                                        <input
                                                                            type="file"
                                                                            multiple
                                                                            id="image_video"
                                                                            accept="image/*,video/*"
                                                                            ref={cameraInputRef}
                                                                            style={{ display: "none" }}
                                                                            onChange={handleFilesChange}
                                                                        />


                                                                        <label htmlFor="file">
                                                                            <File className="icon-add-file-chat"  style={{marginRight: "15px"}}/>
                                                                        </label>
                                                                        <label htmlFor="image_video">
                                                                            <Camera className="icon-add-file-chat" />
                                                                        </label>

                                                                        {/* <File className="icon-add-file-chat"  onClick={handleFileClick} style={{marginRight: "15px"}}/>
                                                                        <Camera className="icon-add-file-chat" onClick={handleCameraClick} /> */}
                                                                    </div>
                                                                </>
                                                            ) : null}
                                                            {/* <div >🚀 Rolou até aqui!</div> */}
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Botão principal direito */}
                                            {recording && (recordingLocked || window.innerWidth > 850) ? (
                                                // Já tem send/cancel dentro da barra — nada aqui
                                                null
                                            ) : !text.trim().length && chatSelected && (!isWebView() || hasNativeMic()) && !selectedFiles.length ? (
                                                // Botão de microfone
                                                <div className="wpp-mic-area">
                                                    {/* Badge de cadeado (flutua acima enquanto arrasta para cima) */}
                                                    {micPressing && (
                                                        <div
                                                            className={`wpp-lock-badge ${micDragY < -55 ? 'wpp-lock-ready' : ''}`}
                                                            style={{
                                                                transform: `translateY(${Math.min(-52, micDragY * 0.55 - 52)}px)`,
                                                                opacity: Math.min(1, Math.abs(micDragY) / 55 + 0.15),
                                                            }}
                                                        >
                                                            {micDragY < -60
                                                                ? <Lock size={16} color="#fff" />
                                                                : <Lock size={16} opacity={0.6} />}
                                                        </div>
                                                    )}

                                                    <button
                                                        type="button"
                                                        className={`btn btn-blue button-submit-chat btn-withou-shadow wpp-mic-btn
                                                            ${micPressing ? 'wpp-mic-holding' : ''}
                                                            ${recording ? 'wpp-mic-recording' : ''}`}
                                                        style={{ touchAction: 'none', userSelect: 'none' }}
                                                        // Mobile: segurar para gravar
                                                        onTouchStart={handleMicTouchStart}
                                                        onTouchMove={handleMicTouchMove}
                                                        onTouchEnd={handleMicTouchEnd}
                                                        onTouchCancel={handleMicTouchEnd}
                                                        // PC: clique para iniciar; send/cancel aparecem na barra
                                                        onClick={() => { if (window.innerWidth > 850 && !recording) startRecording(); }}
                                                    >
                                                        <Mic />
                                                    </button>
                                                </div>
                                            ) : (
                                                // Botões de enviar/editar (código existente sem mudanças)
                                                <>
                                                    {isEdditing && (
                                                        <button style={{ marginRight: "5px" }} onClick={cancelEdit} className="btn btn-red-chat button-submit-chat" type="button">
                                                            <XSquare className="icon-send-chat" />
                                                        </button>
                                                    )}
                                                    <button
                                                        disabled={!text.trim() && !loadingIAResponse && !selectedFiles.length}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        onClick={(e) => { e.preventDefault(); loadingIAResponse ? handleStopResponse() : handleSubmitMessage(); }}
                                                        className="btn btn-blue button-submit-chat btn-withou-shadow"
                                                        type="button"
                                                    >
                                                        {loadingIAResponse
                                                            ? <StopCircle className="icon-send-chat" />
                                                            : <Send className="icon-send-chat" />}
                                                    </button>
                                                </>
                                            )}
                                            {/* {!text.trim().length && chatSelected && (!isWebView() || hasNativeMic()) && !selectedFiles.length ? (
                                                <>
                                                    {!recording ? (
                                                        <button  type="button" className="btn btn-blue button-submit-chat btn-withou-shadow" onClick={startRecording}><Mic/> </button>
                                                    ) : (
                                                        <>
                                                            <button disabled={recordingTime < 2} type="button" className="btn btn-blue button-submit-chat btn-withou-shadow" onClick={() => {stopRecording(true);}}> <Send/>  </button>
                                                            <button  type="button" style={{height: "36px", marginLeft: "5px"}} className="btn btn-red button-submit-chat" onClick={() => {stopRecording();}}> <Trash2/>  </button>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {isEdditing ? (
                                                        <button style={{marginRight: "5px"}} onClick={cancelEdit} className="btn btn-red-chat button-submit-chat" type="button">
                                                            <XSquare className="icon-send-chat" data-feather="send" />
                                                        </button>
                                                    ) : null}

                                                    <button disabled={!text.trim() && !loadingIAResponse && !selectedFiles.length} onMouseDown={(e) => e.preventDefault()} onClick={(e) => { e.preventDefault(); loadingIAResponse ? handleStopResponse() :  handleSubmitMessage() }} className="btn btn-blue button-submit-chat btn-withou-shadow" type="button">
                                                        {loadingIAResponse ? (
                                                            <StopCircle className="icon-send-chat" data-feather="send" />
                                                        ) : (
                                                            <Send className="icon-send-chat" data-feather="send" />
                                                        )}
                                                    </button>
                                                </>
                                            )} */}
                                        </>
                                    )}
                                        </>
                                    )}
                                </form>
                            </div>
                        </>
                </div>
            </div>

            <div className={`image-overlay ${openImage != null ? "active" : ""}`} onClick={() => setOpenImage(null)} >
                <button type="button" onClick={() => setOpenImage(null)} className="btn-x-right btn-close svg-icons-color btn-dark">
                    <X/>
                </button>
            </div>

            {/* AI conversation history drawer — right side, all screens */}
            {showAiConvList && !chatSelected && (
                <div className="ai-conv-drawer-backdrop" onClick={() => setShowAiConvList(false)}>
                    <div className="ai-conv-drawer" onClick={(e) => e.stopPropagation()}>
                        <AiConversationList
                            onClose={() => setShowAiConvList(false)}
                            conversations={aiConversations}
                            activeId={activeConvId}
                            userId={user?.id}
                            onSelect={switchAiConversation}
                            onNew={startNewAiConversation}
                            onDelete={(id) => {
                                if (id === activeConvId) {
                                    setMessages([]);
                                    setActiveConvId(null);
                                    setActiveConversationId(user?.id, null);
                                }
                                setAiConversations(loadConversations(user?.id));
                            }}
                            setConversations={setAiConversations}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default Chat;
